import { GraphQLResolveInfo, GraphQLScalarType, GraphQLScalarTypeConfig } from 'graphql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type RequireFields<T, K extends keyof T> = Omit<T, K> & { [P in K]-?: NonNullable<T[P]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  DateTime: { input: any; output: any; }
};

export type AdAttributionData = {
  __typename?: 'AdAttributionData';
  adGroup: Scalars['String']['output'];
  country: Scalars['String']['output'];
  keyword: Scalars['String']['output'];
  trial: Scalars['Boolean']['output'];
};

export type AiBotUser = {
  __typename?: 'AiBotUser';
  _id: Scalars['String']['output'];
  lastUnansweredMessageDate?: Maybe<Scalars['DateTime']['output']>;
  profileImageUrl?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export enum AlcoholHabit {
  HateAlcohol = 'HATE_ALCOHOL',
  No = 'NO',
  Undisclosed = 'UNDISCLOSED',
  YesEveryDay = 'YES_EVERY_DAY',
  YesParties = 'YES_PARTIES',
  YesSometimes = 'YES_SOMETIMES'
}

export type AnalyticsResult = {
  __typename?: 'AnalyticsResult';
  daus?: Maybe<Array<DauItem>>;
  totalActiveUsersLast30days?: Maybe<Scalars['Int']['output']>;
  totalActiveUsersLast30daysCreatedMoreThan90daysAgo?: Maybe<Scalars['Int']['output']>;
  totalFemaleUsers?: Maybe<Scalars['Int']['output']>;
  totalMaleUsers?: Maybe<Scalars['Int']['output']>;
  totalNewUsersLast30days?: Maybe<Scalars['Int']['output']>;
  totalOtherGenderUsers?: Maybe<Scalars['Int']['output']>;
  totalPayingUsers?: Maybe<Scalars['Int']['output']>;
  totalPayingUsersLast30days?: Maybe<Scalars['Int']['output']>;
  totalUsers?: Maybe<Array<TotalUsersItem>>;
  totalUsersByCountry?: Maybe<Array<TotalUsersCountryItem>>;
  totalUsersLoginApple?: Maybe<Scalars['Int']['output']>;
  totalUsersLoginEmail?: Maybe<Scalars['Int']['output']>;
  totalUsersLoginFacebook?: Maybe<Scalars['Int']['output']>;
  totalUsersLoginGoogle?: Maybe<Scalars['Int']['output']>;
  totalUsersPlatformAndroid?: Maybe<Scalars['Int']['output']>;
  totalUsersPlatformIos?: Maybe<Scalars['Int']['output']>;
  totalUsersPlatformWeb?: Maybe<Scalars['Int']['output']>;
  totalUsersWithPremium?: Maybe<Scalars['Int']['output']>;
  totalVerifiedUsers?: Maybe<Scalars['Int']['output']>;
};

export type AppVersionData = {
  __typename?: 'AppVersionData';
  count: Scalars['Int']['output'];
  version: Scalars['String']['output'];
};

export type Attachment = {
  __typename?: 'Attachment';
  blurhash?: Maybe<Scalars['String']['output']>;
  contentType: Scalars['String']['output'];
  deleted: Scalars['Boolean']['output'];
  expired: Scalars['Boolean']['output'];
  thumbnailUrl: Scalars['String']['output'];
  uploadComplete: Scalars['Boolean']['output'];
  uploadId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum Beard {
  Full = 'FULL',
  Goatee = 'GOATEE',
  Mustache = 'MUSTACHE',
  No = 'NO',
  Short = 'SHORT',
  Undisclosed = 'UNDISCLOSED'
}

export type Chat = {
  __typename?: 'Chat';
  _id: Scalars['String']['output'];
  ended: Scalars['Boolean']['output'];
  endedDate?: Maybe<Scalars['DateTime']['output']>;
  lastMessage?: Maybe<Message>;
  lastMessageId?: Maybe<Scalars['String']['output']>;
  members?: Maybe<Array<Maybe<User>>>;
  messages?: Maybe<PagedMessages>;
  updatedDate: Scalars['DateTime']['output'];
};


export type ChatMessagesArgs = {
  input: PagingArgs;
};

export type ChatFilterInput = {
  requireResponse?: InputMaybe<Scalars['Boolean']['input']>;
  showDeleted?: InputMaybe<Scalars['Boolean']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type ChoiceAnalytics = {
  __typename?: 'ChoiceAnalytics';
  count: Scalars['Int']['output'];
  label: Scalars['String']['output'];
  percentage: Scalars['Float']['output'];
};

export type ChoiceData = {
  __typename?: 'ChoiceData';
  label: Scalars['String']['output'];
};

export type CursorQueryArgs = {
  cursor: Scalars['String']['input'];
  limit: Scalars['Int']['input'];
};

export type DashboardData = {
  __typename?: 'DashboardData';
  dailyActiveUsers: Scalars['Int']['output'];
  monthlyActiveUsers: Scalars['Int']['output'];
  totalBannedUsers: Scalars['Int']['output'];
  totalGroups: Scalars['Int']['output'];
  totalInvites: Scalars['Int']['output'];
  totalPrivatePhotos: Scalars['Int']['output'];
  totalUnresolvedReports: Scalars['Int']['output'];
  totalUnverifiedPhotos: Scalars['Int']['output'];
  totalUnverifiedUsers: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  totalUsersWithApprovedPhoto: Scalars['Int']['output'];
};

export type DauItem = {
  __typename?: 'DauItem';
  date: Scalars['DateTime']['output'];
  mau: Scalars['Int']['output'];
  users: Scalars['Int']['output'];
};

export type DeletedUser = {
  __typename?: 'DeletedUser';
  _id: Scalars['String']['output'];
  deletedReason?: Maybe<Scalars['String']['output']>;
  deletedText?: Maybe<Scalars['String']['output']>;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  username?: Maybe<Scalars['String']['output']>;
};

export type DiamondHistoryEntry = {
  __typename?: 'DiamondHistoryEntry';
  date: Scalars['DateTime']['output'];
  diamondsEarned: Scalars['Int']['output'];
  giftType?: Maybe<Scalars['String']['output']>;
  qualifiedViews?: Maybe<Scalars['Int']['output']>;
  reelId?: Maybe<Scalars['String']['output']>;
  reelThumbnailUrl?: Maybe<Scalars['String']['output']>;
  type: DiamondType;
};

export enum DiamondType {
  Gift = 'GIFT',
  VideoViews = 'VIDEO_VIEWS'
}

export enum Etnicity {
  AfricanAmerican = 'AFRICAN_AMERICAN',
  AmericanIndian = 'AMERICAN_INDIAN',
  Asian = 'ASIAN',
  Hispanic = 'HISPANIC',
  Undisclosed = 'UNDISCLOSED',
  White = 'WHITE'
}

export enum EyeColor {
  Amber = 'AMBER',
  Blue = 'BLUE',
  Brown = 'BROWN',
  Gray = 'GRAY',
  Green = 'GREEN',
  Hazel = 'HAZEL',
  Mixed = 'MIXED',
  Other = 'OTHER',
  Undisclosed = 'UNDISCLOSED'
}

export type FileUploadArgs = {
  contentLength: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export enum FunFact {
  ActedInAFilmAsExtra = 'ACTED_IN_A_FILM_AS_EXTRA',
  AddictedToSpicyFood = 'ADDICTED_TO_SPICY_FOOD',
  AdoreClassicRock = 'ADORE_CLASSIC_ROCK',
  AllergicToChocolate = 'ALLERGIC_TO_CHOCOLATE',
  AllergicToGrass = 'ALLERGIC_TO_GRASS',
  AlwaysCarryLuckyCharm = 'ALWAYS_CARRY_LUCKY_CHARM',
  AmateurMagician = 'AMATEUR_MAGICIAN',
  Ambidextrous = 'AMBIDEXTROUS',
  AmATwin = 'AM_A_TWIN',
  AntiqueCameraCollection = 'ANTIQUE_CAMERA_COLLECTION',
  AvidBulletJournalist = 'AVID_BULLET_JOURNALIST',
  AvidSurfer = 'AVID_SURFER',
  BackflipOnTrampoline = 'BACKFLIP_ON_TRAMPOLINE',
  BakeAmazingPies = 'BAKE_AMAZING_PIES',
  BakeOwnBread = 'BAKE_OWN_BREAD',
  BeenInAFlashMob = 'BEEN_IN_A_FLASH_MOB',
  BeenInTvGameShowAudience = 'BEEN_IN_TV_GAME_SHOW_AUDIENCE',
  BelieveInGhosts = 'BELIEVE_IN_GHOSTS',
  BigFanOfComicBooks = 'BIG_FAN_OF_COMIC_BOOKS',
  BigSciFiNerd = 'BIG_SCI_FI_NERD',
  BikedAcrossACountry = 'BIKED_ACROSS_A_COUNTRY',
  BlackBeltInKarate = 'BLACK_BELT_IN_KARATE',
  BoardGameCollector = 'BOARD_GAME_COLLECTOR',
  BornLeftHanded = 'BORN_LEFT_HANDED',
  BrewOwnBeer = 'BREW_OWN_BEER',
  BrokenBoneDoingSilly = 'BROKEN_BONE_DOING_SILLY',
  BuildMiniatureModels = 'BUILD_MINIATURE_MODELS',
  BuiltMyOwnPc = 'BUILT_MY_OWN_PC',
  CanNameAllPokemon = 'CAN_NAME_ALL_POKEMON',
  CanSkateboard = 'CAN_SKATEBOARD',
  ChessFanatic = 'CHESS_FANATIC',
  ChildSpellingBeeChampion = 'CHILD_SPELLING_BEE_CHAMPION',
  ClimbedVolcano = 'CLIMBED_VOLCANO',
  CoffeeSnob = 'COFFEE_SNOB',
  CollectingPassportStamps = 'COLLECTING_PASSPORT_STAMPS',
  CollectingRareTeas = 'COLLECTING_RARE_TEAS',
  CollectVintagePostcards = 'COLLECT_VINTAGE_POSTCARDS',
  CollectVinylRecords = 'COLLECT_VINYL_RECORDS',
  CompetitiveGamer = 'COMPETITIVE_GAMER',
  ComposeMyOwnMusic = 'COMPOSE_MY_OWN_MUSIC',
  CrashedAWedding = 'CRASHED_A_WEDDING',
  CycledAcrossDesert = 'CYCLED_ACROSS_DESERT',
  DanceLikeNoOneWatching = 'DANCE_LIKE_NO_ONE_WATCHING',
  DesignMyOwnClothes = 'DESIGN_MY_OWN_CLOTHES',
  DislikePineappleOnPizza = 'DISLIKE_PINEAPPLE_ON_PIZZA',
  DonateBloodRegularly = 'DONATE_BLOOD_REGULARLY',
  DrawRealisticPortraits = 'DRAW_REALISTIC_PORTRAITS',
  DyedHairEveryColor = 'DYED_HAIR_EVERY_COLOR',
  DyedHairRainbowColors = 'DYED_HAIR_RAINBOW_COLORS',
  EatenInsectsAbroad = 'EATEN_INSECTS_ABROAD',
  EnjoyColdShowers = 'ENJOY_COLD_SHOWERS',
  EnjoyCreatingDigitalArt = 'ENJOY_CREATING_DIGITAL_ART',
  FascinatedByTrueCrime = 'FASCINATED_BY_TRUE_CRIME',
  FearOfDolls = 'FEAR_OF_DOLLS',
  FenceAsAHobby = 'FENCE_AS_A_HOBBY',
  FoldOrigamiAnimals = 'FOLD_ORIGAMI_ANIMALS',
  GardenInMySpareTime = 'GARDEN_IN_MY_SPARE_TIME',
  GoneDaysWithoutSleep = 'GONE_DAYS_WITHOUT_SLEEP',
  GoneSkydiving = 'GONE_SKYDIVING',
  GrewUpNearTheOcean = 'GREW_UP_NEAR_THE_OCEAN',
  GrewUpOnAFarm = 'GREW_UP_ON_A_FARM',
  HateWearingSocksIndoors = 'HATE_WEARING_SOCKS_INDOORS',
  HaveAFamousDoppelganger = 'HAVE_A_FAMOUS_DOPPELGANGER',
  HaveAMiniLibrary = 'HAVE_A_MINI_LIBRARY',
  HaveAPersonalBlog = 'HAVE_A_PERSONAL_BLOG',
  HaveARescuePet = 'HAVE_A_RESCUE_PET',
  HeldAWorldRecord = 'HELD_A_WORLD_RECORD',
  HiddenTattoo = 'HIDDEN_TATTOO',
  HitchhikedAcrossEurope = 'HITCHHIKED_ACROSS_EUROPE',
  HitchhikedSuccessfully = 'HITCHHIKED_SUCCESSFULLY',
  HugeAnimeFan = 'HUGE_ANIME_FAN',
  HugeFanOfPuzzles = 'HUGE_FAN_OF_PUZZLES',
  HugeStarWarsBuff = 'HUGE_STAR_WARS_BUFF',
  IdentifyConstellationsEasily = 'IDENTIFY_CONSTELLATIONS_EASILY',
  InventNewRecipes = 'INVENT_NEW_RECIPES',
  JuggleThreeItems = 'JUGGLE_THREE_ITEMS',
  JumpedOffAWaterfall = 'JUMPED_OFF_A_WATERFALL',
  KeepADreamJournal = 'KEEP_A_DREAM_JOURNAL',
  KeepBees = 'KEEP_BEES',
  KnowBallroomDance = 'KNOW_BALLROOM_DANCE',
  KnowSignLanguageSongs = 'KNOW_SIGN_LANGUAGE_SONGS',
  LearnedCodingAsAKid = 'LEARNED_CODING_AS_A_KID',
  LearningAFourthLanguage = 'LEARNING_A_FOURTH_LANGUAGE',
  LearningToReadTarot = 'LEARNING_TO_READ_TAROT',
  LearningUkulele = 'LEARNING_UKULELE',
  LearnNewLanguagesForFun = 'LEARN_NEW_LANGUAGES_FOR_FUN',
  LivedInATinyHouse = 'LIVED_IN_A_TINY_HOUSE',
  LivedInThreeCountries = 'LIVED_IN_THREE_COUNTRIES',
  LivedOffGridForAMonth = 'LIVED_OFF_GRID_FOR_A_MONTH',
  LoveBuildingIkeaFurniture = 'LOVE_BUILDING_IKEA_FURNITURE',
  LoveBuildingLegoSets = 'LOVE_BUILDING_LEGO_SETS',
  LoveChangingHairstyle = 'LOVE_CHANGING_HAIRSTYLE',
  LoveCheesyPickUpLines = 'LOVE_CHEESY_PICK_UP_LINES',
  LoveMidnightRoadTrips = 'LOVE_MIDNIGHT_ROAD_TRIPS',
  LovePineappleOnPizza = 'LOVE_PINEAPPLE_ON_PIZZA',
  LovePlayingRetroVideoGames = 'LOVE_PLAYING_RETRO_VIDEO_GAMES',
  LoveQuirkyFashionStyles = 'LOVE_QUIRKY_FASHION_STYLES',
  LoveRepairingOldFurniture = 'LOVE_REPAIRING_OLD_FURNITURE',
  LoveSingingInShower = 'LOVE_SINGING_IN_SHOWER',
  LoveThunderstorms = 'LOVE_THUNDERSTORMS',
  LoveWeirdIceCreamFlavors = 'LOVE_WEIRD_ICE_CREAM_FLAVORS',
  MakeBalloonAnimals = 'MAKE_BALLOON_ANIMALS',
  MakeTheBestPancakes = 'MAKE_THE_BEST_PANCAKES',
  MarathonNetflixBinger = 'MARATHON_NETFLIX_BINGER',
  MatchaLatteFanatic = 'MATCHA_LATTE_FANATIC',
  MemorizeMovieQuotes = 'MEMORIZE_MOVIE_QUOTES',
  MetAUsPresident = 'MET_A_US_PRESIDENT',
  Minimalist = 'MINIMALIST',
  MorningPerson = 'MORNING_PERSON',
  MovedOutAtSixteen = 'MOVED_OUT_AT_SIXTEEN',
  NameEveryStateCapital = 'NAME_EVERY_STATE_CAPITAL',
  NeverBeenOnRollerCoaster = 'NEVER_BEEN_ON_ROLLER_COASTER',
  NeverHadACavity = 'NEVER_HAD_A_CAVITY',
  NeverHadAPet = 'NEVER_HAD_A_PET',
  NightOwl = 'NIGHT_OWL',
  ObsessedWithBulletJournaling = 'OBSESSED_WITH_BULLET_JOURNALING',
  ObsessedWithHauntedHouses = 'OBSESSED_WITH_HAUNTED_HOUSES',
  ObsessedWithSpaceExploration = 'OBSESSED_WITH_SPACE_EXPLORATION',
  ObsessedWithTriviaGames = 'OBSESSED_WITH_TRIVIA_GAMES',
  OfficialGuinnessRecordHolder = 'OFFICIAL_GUINNESS_RECORD_HOLDER',
  OneHandedPushup = 'ONE_HANDED_PUSHUP',
  OwnVintageArcadeMachine = 'OWN_VINTAGE_ARCADE_MACHINE',
  PaintWatercolorLandscapes = 'PAINT_WATERCOLOR_LANDSCAPES',
  ParticipatedPolarPlunge = 'PARTICIPATED_POLAR_PLUNGE',
  PartOfFlashDanceMob = 'PART_OF_FLASH_DANCE_MOB',
  PassionateAboutSlowTravel = 'PASSIONATE_ABOUT_SLOW_TRAVEL',
  PassionateAboutZeroWaste = 'PASSIONATE_ABOUT_ZERO_WASTE',
  PerfectCartwheel = 'PERFECT_CARTWHEEL',
  PerformedInACircusAct = 'PERFORMED_IN_A_CIRCUS_ACT',
  PerformedOnStage = 'PERFORMED_ON_STAGE',
  PerformedStandupComedyOnce = 'PERFORMED_STANDUP_COMEDY_ONCE',
  PerformedWithABand = 'PERFORMED_WITH_A_BAND',
  PhobiaOfHeights = 'PHOBIA_OF_HEIGHTS',
  PlayedSportAtNationalLevel = 'PLAYED_SPORT_AT_NATIONAL_LEVEL',
  PlayBagpipes = 'PLAY_BAGPIPES',
  PracticeYogaDaily = 'PRACTICE_YOGA_DAILY',
  PreferSaltyOverSweet = 'PREFER_SALTY_OVER_SWEET',
  PuzzleEscapeRoomFan = 'PUZZLE_ESCAPE_ROOM_FAN',
  RaisedChickens = 'RAISED_CHICKENS',
  RaiseHouseplantsLikePets = 'RAISE_HOUSEPLANTS_LIKE_PETS',
  ReadHarryPotter_5X = 'READ_HARRY_POTTER_5X',
  ReadOneBookAWeek = 'READ_ONE_BOOK_A_WEEK',
  ReallyIntoConspiracyTheories = 'REALLY_INTO_CONSPIRACY_THEORIES',
  ReallyIntoGenealogy = 'REALLY_INTO_GENEALOGY',
  ReciteAlphabetBackward = 'RECITE_ALPHABET_BACKWARD',
  RecordedAPodcast = 'RECORDED_A_PODCAST',
  RiddenACamel = 'RIDDEN_A_CAMEL',
  RollTongueThreeWays = 'ROLL_TONGUE_THREE_WAYS',
  RunAFoodBlog = 'RUN_A_FOOD_BLOG',
  RunAMarathon = 'RUN_A_MARATHON',
  RunInTheRain = 'RUN_IN_THE_RAIN',
  RunWithTheBulls = 'RUN_WITH_THE_BULLS',
  ScaredOfButterflies = 'SCARED_OF_BUTTERFLIES',
  SecretlyGoodAtKaraoke = 'SECRETLY_GOOD_AT_KARAOKE',
  SelfTaughtAnInstrument = 'SELF_TAUGHT_AN_INSTRUMENT',
  SetFootInArcticCircle = 'SET_FOOT_IN_ARCTIC_CIRCLE',
  SleptUnderStarsInDesert = 'SLEPT_UNDER_STARS_IN_DESERT',
  SnapWithTwoFingers = 'SNAP_WITH_TWO_FINGERS',
  SolveRubiksCube = 'SOLVE_RUBIKS_CUBE',
  SpeakFluentSignLanguage = 'SPEAK_FLUENT_SIGN_LANGUAGE',
  SpeakMovieTrailerVoice = 'SPEAK_MOVIE_TRAILER_VOICE',
  SpeedReader = 'SPEED_READER',
  SpeedTypist = 'SPEED_TYPIST',
  SpentAYearTravelingSolo = 'SPENT_A_YEAR_TRAVELING_SOLO',
  SpentNightInMuseum = 'SPENT_NIGHT_IN_MUSEUM',
  StandupComedyJunkie = 'STANDUP_COMEDY_JUNKIE',
  StayedAwake_48Hours = 'STAYED_AWAKE_48_HOURS',
  StillHaveChildhoodTeddyBear = 'STILL_HAVE_CHILDHOOD_TEDDY_BEAR',
  StrongBelieverInKarma = 'STRONG_BELIEVER_IN_KARMA',
  StudiedAbroadInJapan = 'STUDIED_ABROAD_IN_JAPAN',
  StudiedLatin = 'STUDIED_LATIN',
  SuckerForRomComs = 'SUCKER_FOR_ROM_COMS',
  SuperstitiousAbout_13 = 'SUPERSTITIOUS_ABOUT_13',
  SwumWithSharks = 'SWUM_WITH_SHARKS',
  TerrifiedOfClowns = 'TERRIFIED_OF_CLOWNS',
  TookPotteryClasses = 'TOOK_POTTERY_CLASSES',
  TriedBungeeJumping = 'TRIED_BUNGEE_JUMPING',
  TriedGlassBlowing = 'TRIED_GLASS_BLOWING',
  TriedProWrestlingTraining = 'TRIED_PRO_WRESTLING_TRAINING',
  TriedSnailDelicacies = 'TRIED_SNAIL_DELICACIES',
  TriedStandupComedy = 'TRIED_STANDUP_COMEDY',
  TriedToAdoptPetPig = 'TRIED_TO_ADOPT_PET_PIG',
  UnusualLaugh = 'UNUSUAL_LAUGH',
  UsedToBeFlightAttendant = 'USED_TO_BE_FLIGHT_ATTENDANT',
  UsedToWriteFanFiction = 'USED_TO_WRITE_FAN_FICTION',
  Vegan = 'VEGAN',
  VeryGoodAtSudoku = 'VERY_GOOD_AT_SUDOKU',
  VisitedAllSevenContinents = 'VISITED_ALL_SEVEN_CONTINENTS',
  VisitedWolfSanctuary = 'VISITED_WOLF_SANCTUARY',
  VoiceActingHobby = 'VOICE_ACTING_HOBBY',
  VolunteerAtAnAnimalShelter = 'VOLUNTEER_AT_AN_ANIMAL_SHELTER',
  VolunteerBigSiblingMentor = 'VOLUNTEER_BIG_SIBLING_MENTOR',
  WasOnLocalTvShow = 'WAS_ON_LOCAL_TV_SHOW',
  WatchHorrorMoviesAlone = 'WATCH_HORROR_MOVIES_ALONE',
  WeaknessForMemes = 'WEAKNESS_FOR_MEMES',
  WhistleReallyLoud = 'WHISTLE_REALLY_LOUD',
  WonAScienceFair = 'WON_A_SCIENCE_FAIR',
  WonDanceContest = 'WON_DANCE_CONTEST',
  WonHotDogEatingContest = 'WON_HOT_DOG_EATING_CONTEST',
  WroteAShortNovel = 'WROTE_A_SHORT_NOVEL'
}

export enum Gender {
  Man = 'MAN',
  NonBinary = 'NON_BINARY',
  Transgender = 'TRANSGENDER',
  Undisclosed = 'UNDISCLOSED',
  Woman = 'WOMAN'
}

export type GenderDistribution = {
  __typename?: 'GenderDistribution';
  femaleUsers: Scalars['Int']['output'];
  maleUsers: Scalars['Int']['output'];
  otherGenderUsers: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type Geo = {
  __typename?: 'Geo';
  _id: Scalars['String']['output'];
  coordinates?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
  type?: Maybe<Scalars['String']['output']>;
};

export type GeoInput = {
  coordinates?: InputMaybe<Array<InputMaybe<Scalars['Float']['input']>>>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type GeocodeResult = {
  __typename?: 'GeocodeResult';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
};

export type Group = {
  __typename?: 'Group';
  _id: Scalars['String']['output'];
  about: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  genderLimited: Array<Scalars['String']['output']>;
  maxAgeLimited: Scalars['Int']['output'];
  memberCommentsAllowed: Scalars['Boolean']['output'];
  memberPostsAllowed: Scalars['Boolean']['output'];
  memberVisibility: MemberVisibility;
  minAgeLimited: Scalars['Int']['output'];
  name: Scalars['String']['output'];
  photo?: Maybe<Photo>;
  privacy: GroupPrivacy;
  rules: Scalars['String']['output'];
  visibility: GroupVisibility;
};

export enum GroupPrivacy {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

export enum GroupStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED',
  Review = 'REVIEW'
}

export enum GroupVisibility {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

export enum HairColor {
  Black = 'BLACK',
  Blonde = 'BLONDE',
  Brown = 'BROWN',
  Colored = 'COLORED',
  Gray = 'GRAY',
  Red = 'RED',
  Shaved = 'SHAVED',
  Undisclosed = 'UNDISCLOSED'
}

export enum HereTo {
  Chat = 'CHAT',
  Date = 'DATE',
  Friendship = 'FRIENDSHIP',
  OneNight = 'ONE_NIGHT',
  Relationship = 'RELATIONSHIP'
}

export enum Interest {
  Beaches = 'BEACHES',
  Business = 'BUSINESS',
  Cars = 'CARS',
  Cats = 'CATS',
  Chill = 'CHILL',
  Clothes = 'CLOTHES',
  Coffee = 'COFFEE',
  Comedies = 'COMEDIES',
  Cooking = 'COOKING',
  CultureAndBooks = 'CULTURE_AND_BOOKS',
  Diving = 'DIVING',
  Dogs = 'DOGS',
  Driving = 'DRIVING',
  FashionAndBeauty = 'FASHION_AND_BEAUTY',
  FoodAndDrink = 'FOOD_AND_DRINK',
  Football = 'FOOTBALL',
  Friendship = 'FRIENDSHIP',
  Gaming = 'GAMING',
  Gym = 'GYM',
  Hobbies = 'HOBBIES',
  Horses = 'HORSES',
  IceCream = 'ICE_CREAM',
  Laughing = 'LAUGHING',
  Love = 'LOVE',
  MeetPeople = 'MEET_PEOPLE',
  MotorBikes = 'MOTOR_BIKES',
  MoviesAndSeries = 'MOVIES_AND_SERIES',
  Music = 'MUSIC',
  Painting = 'PAINTING',
  Party = 'PARTY',
  RoadTrips = 'ROAD_TRIPS',
  RockMusic = 'ROCK_MUSIC',
  Running = 'RUNNING',
  Sex = 'SEX',
  Shoes = 'SHOES',
  Skateboard = 'SKATEBOARD',
  Skiing = 'SKIING',
  Snowboard = 'SNOWBOARD',
  Sport = 'SPORT',
  StockMarket = 'STOCK_MARKET',
  Summer = 'SUMMER',
  Surfing = 'SURFING',
  Tea = 'TEA',
  Travel = 'TRAVEL',
  Walking = 'WALKING',
  WeekendTrips = 'WEEKEND_TRIPS',
  Winter = 'WINTER',
  WorkOut = 'WORK_OUT'
}

export enum KidsStatus {
  NoMaybeLater = 'NO_MAYBE_LATER',
  NoNever = 'NO_NEVER',
  Undisclosed = 'UNDISCLOSED',
  YesAdults = 'YES_ADULTS',
  YesFulltime = 'YES_FULLTIME',
  YesParttime = 'YES_PARTTIME',
  YesWantMore = 'YES_WANT_MORE'
}

export enum Living {
  Apartment = 'APARTMENT',
  Hotel = 'HOTEL',
  House = 'HOUSE',
  Undisclosed = 'UNDISCLOSED',
  WithParents = 'WITH_PARENTS'
}

export enum Language {
  Arabic = 'ARABIC',
  Bulgarian = 'BULGARIAN',
  Catalan = 'CATALAN',
  Chinese = 'CHINESE',
  Croatian = 'CROATIAN',
  Czech = 'CZECH',
  Danish = 'DANISH',
  Dutch = 'DUTCH',
  English = 'ENGLISH',
  Estonian = 'ESTONIAN',
  Filipino = 'FILIPINO',
  Finnish = 'FINNISH',
  French = 'FRENCH',
  German = 'GERMAN',
  Greek = 'GREEK',
  Hindi = 'HINDI',
  Hungarian = 'HUNGARIAN',
  Indonesian = 'INDONESIAN',
  Italian = 'ITALIAN',
  Japanese = 'JAPANESE',
  Khmer = 'KHMER',
  Korean = 'KOREAN',
  Latvian = 'LATVIAN',
  Lithuanian = 'LITHUANIAN',
  Malay = 'MALAY',
  Norwegian = 'NORWEGIAN',
  Polish = 'POLISH',
  Portuguese = 'PORTUGUESE',
  Romanian = 'ROMANIAN',
  Russian = 'RUSSIAN',
  Slovak = 'SLOVAK',
  Spanish = 'SPANISH',
  Swedish = 'SWEDISH',
  Thai = 'THAI',
  Turkish = 'TURKISH',
  Ukranian = 'UKRANIAN',
  Vietnamese = 'VIETNAMESE'
}

export type LanguageString = {
  __typename?: 'LanguageString';
  lang: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type LivePagingResult = {
  __typename?: 'LivePagingResult';
  hasNextPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  offset: Scalars['Int']['output'];
  totalDocs: Scalars['Int']['output'];
};

export type LiveStream = {
  __typename?: 'LiveStream';
  _id: Scalars['ID']['output'];
  allowComments: Scalars['Boolean']['output'];
  allowGifts: Scalars['Boolean']['output'];
  createdAt: Scalars['DateTime']['output'];
  currentViewerCount: Scalars['Int']['output'];
  description?: Maybe<Scalars['String']['output']>;
  endedAt?: Maybe<Scalars['DateTime']['output']>;
  hostUser: LiveStreamUser;
  isPrivate: Scalars['Boolean']['output'];
  peakViewerCount: Scalars['Int']['output'];
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  status: LiveStreamStatus;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  totalDiamondsEarned: Scalars['Int']['output'];
};

export enum LiveStreamStatus {
  Cancelled = 'CANCELLED',
  Ended = 'ENDED',
  Live = 'LIVE'
}

export type LiveStreamUser = {
  __typename?: 'LiveStreamUser';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
  profilePhotoThumbnailUrl: Scalars['String']['output'];
  profilePhotoUrl: Scalars['String']['output'];
};

export type LiveStreamingApplication = {
  __typename?: 'LiveStreamingApplication';
  date: Scalars['DateTime']['output'];
  decidedBy?: Maybe<Scalars['String']['output']>;
  decidedDate?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  retryAfterDate?: Maybe<Scalars['DateTime']['output']>;
  /** pending | approved | rejected */
  status: Scalars['String']['output'];
  ticketId: Scalars['String']['output'];
  ticketNumber: Scalars['Int']['output'];
};

export type Location = {
  __typename?: 'Location';
  _id: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  geo?: Maybe<Geo>;
};

export type LocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  geo?: InputMaybe<GeoInput>;
};

export type LoginResult = {
  __typename?: 'LoginResult';
  authenticated: Scalars['Boolean']['output'];
  token?: Maybe<Scalars['String']['output']>;
};

export enum MeetType {
  Coffee = 'Coffee',
  Date = 'Date',
  Dinner = 'Dinner',
  Hangout = 'Hangout',
  Hookup = 'Hookup',
  OneNightStand = 'OneNightStand',
  Party = 'Party',
  Sport = 'Sport'
}

export enum MeetWhen {
  NextWeek = 'NextWeek',
  ThisWeek = 'ThisWeek',
  ThisWeekend = 'ThisWeekend',
  Today = 'Today',
  Tomorrow = 'Tomorrow',
  Within30Days = 'Within30Days'
}

export enum MemberVisibility {
  Hidden = 'HIDDEN',
  Visible = 'VISIBLE'
}

export type Message = {
  __typename?: 'Message';
  _id: Scalars['String']['output'];
  chatId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  fromId: Scalars['String']['output'];
  text: Scalars['String']['output'];
  viewedByIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type Mutation = {
  __typename?: 'Mutation';
  _?: Maybe<Scalars['Boolean']['output']>;
  /** Internal note on the ticket, never sent to the user */
  addSupportTicketNote: SupportTicket;
  approveGroup?: Maybe<Scalars['String']['output']>;
  approveGroupPhoto?: Maybe<Scalars['String']['output']>;
  approveMatchVideo?: Maybe<Scalars['String']['output']>;
  approvePhoto?: Maybe<Scalars['String']['output']>;
  approvePhotoVerification?: Maybe<Scalars['String']['output']>;
  approveProfilePhoto?: Maybe<Scalars['String']['output']>;
  approveReel?: Maybe<Scalars['String']['output']>;
  approveVideo?: Maybe<Scalars['String']['output']>;
  banUserFromLiveStreaming: Scalars['Boolean']['output'];
  deleteReel?: Maybe<Scalars['String']['output']>;
  deleteReelComment: Scalars['Boolean']['output'];
  deleteUser?: Maybe<Scalars['String']['output']>;
  deleteVoiceRecording?: Maybe<Scalars['String']['output']>;
  endLiveStream: Scalars['Boolean']['output'];
  fixMan?: Maybe<Scalars['String']['output']>;
  googleLogin?: Maybe<LoginResult>;
  markReelForHlsConvert?: Maybe<Scalars['String']['output']>;
  promoteReel?: Maybe<Scalars['String']['output']>;
  /**
   * Send a reply through the support desk (email, or the app chat for chat
   * tickets). The recipient is always the ticket's own sender. resolve true
   * closes the ticket, false leaves it waiting for the user.
   */
  replySupportTicket: SupportTicket;
  reviewPost?: Maybe<Scalars['String']['output']>;
  sendMessage: Scalars['String']['output'];
  sendPush?: Maybe<Scalars['String']['output']>;
  setBan?: Maybe<Scalars['String']['output']>;
  setLiveBan: Scalars['Boolean']['output'];
  /**
   * Approve (true) or reject/revoke (false) a user's live streaming access.
   * reason and retryAfterDays only apply to false; retryAfterDays null means the
   * user may never apply again.
   */
  setLiveStreamingApproved: Scalars['Boolean']['output'];
  /**
   * Updates the user-visible description text on a reel. Used by admins to
   * moderate the description (e.g. strip slurs, fix typos) without rejecting
   * the reel entirely. Pass an empty string to clear the description.
   */
  setReelDescription?: Maybe<Scalars['String']['output']>;
  /**
   * Marks a legacy reel's video upload for HLS backfill by setting
   * markedForHLS=true on the UploadModel. The scheduled reels HLS backfill
   * lambda picks this up on its next run and moves the upload into the
   * HLS pipeline. See video-pipeline/VIDEO_HLS_PLAN.md Stage 8.
   */
  setReelExplicit?: Maybe<Scalars['String']['output']>;
  /**
   * status: open (reopen) | resolved | spam | archived | snoozed. snoozeDays
   * only applies to snoozed (1 to 60, default 3). note is stored on the ticket.
   */
  setSupportTicketStatus: SupportTicket;
  /**
   * Generates a presigned POST URL for uploading a custom thumbnail for a reel.
   * Used by the backoffice frame-selector UI: the admin pauses the video,
   * captures the current frame, and this mutation returns a presigned POST URL
   * that the client uses to upload the image directly to S3. After the upload
   * completes, the standard photo pipeline processes the image.
   */
  uploadReelThumbnail?: Maybe<PhotoUploadResult>;
  viewChat: Scalars['String']['output'];
};


export type MutationAddSupportTicketNoteArgs = {
  _id: Scalars['String']['input'];
  text: Scalars['String']['input'];
};


export type MutationApproveGroupArgs = {
  groupId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationApproveGroupPhotoArgs = {
  groupId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationApproveMatchVideoArgs = {
  userId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationApprovePhotoArgs = {
  uploadId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationApprovePhotoVerificationArgs = {
  userId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationApproveProfilePhotoArgs = {
  rejectReason?: InputMaybe<PhotoRejectReason>;
  userId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationApproveReelArgs = {
  explicit: Scalars['Boolean']['input'];
  matchVideo: Scalars['Boolean']['input'];
  reelId: Scalars['String']['input'];
  rejectReason: ReelRejectReason;
  value: Scalars['Boolean']['input'];
};


export type MutationApproveVideoArgs = {
  uploadId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationBanUserFromLiveStreamingArgs = {
  streamId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationDeleteReelArgs = {
  reelId: Scalars['String']['input'];
};


export type MutationDeleteReelCommentArgs = {
  commentId: Scalars['String']['input'];
};


export type MutationDeleteUserArgs = {
  userId: Scalars['String']['input'];
};


export type MutationDeleteVoiceRecordingArgs = {
  uploadId: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};


export type MutationEndLiveStreamArgs = {
  streamId: Scalars['String']['input'];
};


export type MutationFixManArgs = {
  userId: Scalars['String']['input'];
};


export type MutationGoogleLoginArgs = {
  captcha: Scalars['String']['input'];
  token: Scalars['String']['input'];
};


export type MutationMarkReelForHlsConvertArgs = {
  reelId: Scalars['String']['input'];
};


export type MutationPromoteReelArgs = {
  reelId: Scalars['String']['input'];
};


export type MutationReplySupportTicketArgs = {
  _id: Scalars['String']['input'];
  resolve: Scalars['Boolean']['input'];
  text: Scalars['String']['input'];
};


export type MutationReviewPostArgs = {
  postId: Scalars['String']['input'];
  reviewStatus: PostReviewStatus;
};


export type MutationSendMessageArgs = {
  input: SendMessageToChatArgs;
};


export type MutationSendPushArgs = {
  args: SendPushArgs;
};


export type MutationSetBanArgs = {
  _id: Scalars['String']['input'];
  until?: InputMaybe<Scalars['DateTime']['input']>;
  value: Scalars['Boolean']['input'];
};


export type MutationSetLiveBanArgs = {
  userId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationSetLiveStreamingApprovedArgs = {
  reason?: InputMaybe<Scalars['String']['input']>;
  retryAfterDays?: InputMaybe<Scalars['Int']['input']>;
  userId: Scalars['String']['input'];
  value: Scalars['Boolean']['input'];
};


export type MutationSetReelDescriptionArgs = {
  description: Scalars['String']['input'];
  reelId: Scalars['String']['input'];
};


export type MutationSetReelExplicitArgs = {
  explicit: Scalars['Boolean']['input'];
  reelId: Scalars['String']['input'];
};


export type MutationSetSupportTicketStatusArgs = {
  _id: Scalars['String']['input'];
  note?: InputMaybe<Scalars['String']['input']>;
  snoozeDays?: InputMaybe<Scalars['Int']['input']>;
  status: Scalars['String']['input'];
};


export type MutationUploadReelThumbnailArgs = {
  contentLength: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  reelId: Scalars['String']['input'];
};


export type MutationViewChatArgs = {
  chatId: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type OffsetQueryArgs = {
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
};

export type OnboardingArgs = {
  fromDate: Scalars['DateTime']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['DateTime']['input'];
};

export type OnboardingData = {
  __typename?: 'OnboardingData';
  appVersions: Array<AppVersionData>;
  atAuth: Scalars['Int']['output'];
  atMatch: Scalars['Int']['output'];
  atPreferences: Scalars['Int']['output'];
  atReady: Scalars['Int']['output'];
  date: Scalars['DateTime']['output'];
  femaleFinishedOnboarding: Scalars['Int']['output'];
  inviteCodesUsed: Scalars['Int']['output'];
  newPremium1Week: Scalars['Int']['output'];
  newPremium3Months: Scalars['Int']['output'];
  photoFinishedOnboarding: Scalars['Int']['output'];
  platform: Scalars['String']['output'];
  pushFinishedOnboarding: Scalars['Int']['output'];
  renewalPremium1Week: Scalars['Int']['output'];
  renewalPremium3Months: Scalars['Int']['output'];
  subscriptionSources: Array<SubscriptionSourceData>;
  totalActiveInviteCodes: Scalars['Int']['output'];
  totalBoostIap: Scalars['Int']['output'];
  totalFinishedOnboarding: Scalars['Int']['output'];
  totalHotLikesIap: Scalars['Int']['output'];
  totalIapUsers: Scalars['Int']['output'];
  totalLiveGiftIap: Scalars['Int']['output'];
  totalPremiumOnboarding: Scalars['Int']['output'];
  totalPremiumUsers: Scalars['Int']['output'];
  totalPushActivated: Scalars['Int']['output'];
  totalRewardedAdsWatched: Scalars['Int']['output'];
  totalSpotlightIap: Scalars['Int']['output'];
  totalUnlockChatIap: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
  totalVotesIap: Scalars['Int']['output'];
  totalWinksIap: Scalars['Int']['output'];
  userCount: Scalars['Int']['output'];
};

export type OnboardingHistoryArgs = {
  fromDate: Scalars['DateTime']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['DateTime']['input'];
};

export type OnboardingHistoryData = {
  __typename?: 'OnboardingHistoryData';
  onboardingData: Array<OnboardingData>;
};

export type OnboardingResult = {
  __typename?: 'OnboardingResult';
  activeAtAuth: Scalars['Int']['output'];
  activeAtMatch: Scalars['Int']['output'];
  activeAtMatchingPreferences: Scalars['Int']['output'];
  activeAtReady: Scalars['Int']['output'];
  atAuth: GenderDistribution;
  atMatch: GenderDistribution;
  atMatchingPreferences: GenderDistribution;
  atReady: GenderDistribution;
  finishedOnboarding: GenderDistribution;
  finishedOnboardingWithLocation: Scalars['Int']['output'];
  finishedOnboardingWithPhoto: Scalars['Int']['output'];
  finishedOnboardingWithPhotoFemale: Scalars['Int']['output'];
  finishedOnboardingWithPhotoMale: Scalars['Int']['output'];
  premiumOnboarding: Scalars['Int']['output'];
  premiumTotal: Scalars['Int']['output'];
  premiumWithoutFlag: Scalars['Int']['output'];
  totalDistribution: GenderDistribution;
  totalPushActivated: Scalars['Int']['output'];
  totalRewardedAdsWatched: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export type PageQueryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
};

export type PagedChats = {
  __typename?: 'PagedChats';
  nodes: Array<Chat>;
  paging: PagingResult;
};

export type PagedLiveStreams = {
  __typename?: 'PagedLiveStreams';
  nodes: Array<LiveStream>;
  paging: LivePagingResult;
};

export type PagedMessages = {
  __typename?: 'PagedMessages';
  nodes: Array<Message>;
  paging: PagingResult;
};

export type PagedPhotos = {
  __typename?: 'PagedPhotos';
  nodes: Array<Photo>;
  paging: PagingResult;
};

export type PagedReelComments = {
  __typename?: 'PagedReelComments';
  nodes: Array<ReelComment>;
  paging: PagingResult;
};

export type PagedSupportTickets = {
  __typename?: 'PagedSupportTickets';
  hasNextPage: Scalars['Boolean']['output'];
  limit: Scalars['Int']['output'];
  nodes: Array<SupportTicket>;
  offset: Scalars['Int']['output'];
  total: Scalars['Int']['output'];
};

export type PagedUsers = {
  __typename?: 'PagedUsers';
  nodes: Array<User>;
  paging: PagingResult;
};

export type PagedVideos = {
  __typename?: 'PagedVideos';
  nodes: Array<Video>;
  paging: PagingResult;
};

export type PagingArgs = {
  cursorArgs?: InputMaybe<CursorQueryArgs>;
  offsetArgs?: InputMaybe<OffsetQueryArgs>;
  pageArgs?: InputMaybe<PageQueryArgs>;
  type: Scalars['String']['input'];
};

export type PagingResult = {
  __typename?: 'PagingResult';
  hasNextPage?: Maybe<Scalars['Boolean']['output']>;
  hasPrevPage?: Maybe<Scalars['Boolean']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  nextPage?: Maybe<Scalars['Int']['output']>;
  offset?: Maybe<Scalars['Int']['output']>;
  page?: Maybe<Scalars['Int']['output']>;
  pagingCounter?: Maybe<Scalars['Int']['output']>;
  prevPage?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type PaidConversionArgs = {
  fromDate: Scalars['DateTime']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['DateTime']['input'];
};

export type PaidConversionResult = {
  __typename?: 'PaidConversionResult';
  purchasesFromExistingUsers: Scalars['Int']['output'];
  sources: Array<PaidConversionSourceData>;
  totalOnboardingFinished: Scalars['Int']['output'];
  totalSubscriptions: Scalars['Int']['output'];
  totalUsersCreated: Scalars['Int']['output'];
};

export type PaidConversionSourceData = {
  __typename?: 'PaidConversionSourceData';
  count: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export enum PersonalityTrait {
  Adventurous = 'Adventurous',
  Ambitious = 'Ambitious',
  Caring = 'Caring',
  Charismatic = 'Charismatic',
  Charming = 'Charming',
  Clever = 'Clever',
  Considerate = 'Considerate',
  Courageous = 'Courageous',
  Discreet = 'Discreet',
  Dramatic = 'Dramatic',
  Educated = 'Educated',
  Elegant = 'Elegant',
  Empathetic = 'Empathetic',
  Energetic = 'Energetic',
  Enthusiastic = 'Enthusiastic',
  Esthetic = 'Esthetic',
  Fair = 'Fair',
  Faithful = 'Faithful',
  Flexible = 'Flexible',
  Forgiving = 'Forgiving',
  Friendly = 'Friendly',
  Funny = 'Funny',
  Generous = 'Generous',
  Helpful = 'Helpful',
  Heroic = 'Heroic',
  Honest = 'Honest',
  Humble = 'Humble',
  Independent = 'Independent',
  Intelligent = 'Intelligent',
  Kind = 'Kind',
  Leader = 'Leader',
  Lovable = 'Lovable',
  Loving = 'Loving',
  Masculine = 'Masculine',
  Mature = 'Mature',
  Modest = 'Modest',
  Open = 'Open',
  Optimistic = 'Optimistic',
  Organized = 'Organized',
  Outgoing = 'Outgoing',
  Passionate = 'Passionate',
  Patient = 'Patient',
  Peaceful = 'Peaceful',
  Perfectionist = 'Perfectionist',
  Playful = 'Playful',
  Popular = 'Popular',
  Precise = 'Precise',
  Protective = 'Protective',
  Rational = 'Rational',
  Realistic = 'Realistic',
  Relaxed = 'Relaxed',
  Reliable = 'Reliable',
  Responsible = 'Responsible',
  Romantic = 'Romantic',
  Selfless = 'Selfless',
  Sensitive = 'Sensitive',
  Sentimental = 'Sentimental',
  Serious = 'Serious',
  Sharing = 'Sharing',
  Simple = 'Simple',
  Sociable = 'Sociable',
  Sophisticated = 'Sophisticated',
  Spontaneous = 'Spontaneous',
  Sweet = 'Sweet',
  Sympathetic = 'Sympathetic',
  Tasteful = 'Tasteful',
  Thoughtful = 'Thoughtful',
  Tolerant = 'Tolerant',
  Trusting = 'Trusting',
  Trustworthy = 'Trustworthy',
  Understanding = 'Understanding',
  Warm = 'Warm',
  Warmhearted = 'Warmhearted',
  Wise = 'Wise',
  Witty = 'Witty',
  Youthful = 'Youthful'
}

export type Photo = {
  __typename?: 'Photo';
  _id: Scalars['String']['output'];
  approved: Scalars['Boolean']['output'];
  blurhash?: Maybe<Scalars['String']['output']>;
  isPrivate: Scalars['Boolean']['output'];
  moderation?: Maybe<PhotoModeration>;
  platform?: Maybe<Scalars['String']['output']>;
  thumbnailUrl: Scalars['String']['output'];
  uploadById?: Maybe<Scalars['String']['output']>;
  uploadComplete: Scalars['Boolean']['output'];
  uploadId: Scalars['String']['output'];
  url: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type PhotoModeration = {
  __typename?: 'PhotoModeration';
  ageRangeHigh?: Maybe<Scalars['Int']['output']>;
  ageRangeLow?: Maybe<Scalars['Int']['output']>;
  celebrityConfidence?: Maybe<Scalars['Int']['output']>;
  celebrityName?: Maybe<Scalars['String']['output']>;
  checkedDate?: Maybe<Scalars['DateTime']['output']>;
  faceCount?: Maybe<Scalars['Int']['output']>;
  genderConfidence?: Maybe<Scalars['Int']['output']>;
  genderDetected?: Maybe<Scalars['String']['output']>;
  graphicsLabels?: Maybe<Array<Scalars['String']['output']>>;
  moderationLabels?: Maybe<Array<Scalars['String']['output']>>;
  outcome?: Maybe<Scalars['String']['output']>;
  rejectReason?: Maybe<Scalars['String']['output']>;
  reviewReasons?: Maybe<Array<Scalars['String']['output']>>;
};

export enum PhotoRejectReason {
  ContainsChildren = 'ContainsChildren',
  ContainsGraphics = 'ContainsGraphics',
  GenderMismatch = 'GenderMismatch',
  ImageFoundOnInternet = 'ImageFoundOnInternet',
  Inappropriate = 'Inappropriate',
  MultiplePeople = 'MultiplePeople',
  NotAPerson = 'NotAPerson',
  PoorQuality = 'PoorQuality'
}

export type PhotoUploadArgs = {
  contentLength: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type PhotoUploadResult = {
  __typename?: 'PhotoUploadResult';
  uploadId: Scalars['String']['output'];
  uploadPostInfo: UploadPostInfo;
};

export type PhotoVerification = {
  __typename?: 'PhotoVerification';
  profilePhoto: Photo;
  userId: Scalars['String']['output'];
  verifyPhoto: Photo;
};

export type PlaceAutocomplete = {
  __typename?: 'PlaceAutocomplete';
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  geo?: Maybe<Geo>;
};

export type Post = {
  __typename?: 'Post';
  _id: Scalars['String']['output'];
  attachments?: Maybe<Array<Attachment>>;
  audience: PostAudience;
  byUserId: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  reviewStatus: PostReviewStatus;
  text?: Maybe<Scalars['String']['output']>;
};

export enum PostAudience {
  Followers = 'FOLLOWERS',
  Friends = 'FRIENDS',
  Group = 'GROUP',
  Matches = 'MATCHES',
  Public = 'PUBLIC'
}

export enum PostReviewStatus {
  Approved = 'Approved',
  Pending = 'Pending',
  Rejected = 'Rejected'
}

export type Profile = {
  __typename?: 'Profile';
  _id: Scalars['String']['output'];
  alcohol?: Maybe<AlcoholHabit>;
  beard?: Maybe<Beard>;
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  birthDateChanged?: Maybe<Scalars['DateTime']['output']>;
  describeYourself?: Maybe<Scalars['String']['output']>;
  etnicity?: Maybe<Etnicity>;
  eyeColor?: Maybe<EyeColor>;
  firstName?: Maybe<Scalars['String']['output']>;
  funFacts?: Maybe<Array<Scalars['String']['output']>>;
  gender?: Maybe<Gender>;
  hairColor?: Maybe<HairColor>;
  hereTo?: Maybe<HereTo>;
  interests?: Maybe<Array<Interest>>;
  kids?: Maybe<KidsStatus>;
  languages?: Maybe<Array<Language>>;
  lastName?: Maybe<Scalars['String']['output']>;
  length?: Maybe<Scalars['Int']['output']>;
  living?: Maybe<Living>;
  location?: Maybe<ProfileLocation>;
  lookingFor?: Maybe<Array<Gender>>;
  mood?: Maybe<Scalars['String']['output']>;
  personality?: Maybe<Array<PersonalityTrait>>;
  relationshipStatus?: Maybe<RelationshipStatus>;
  religion?: Maybe<Religion>;
  sexuality?: Maybe<Sexuality>;
  smoking?: Maybe<SmokingHabit>;
  tattoo?: Maybe<Tattoo>;
  temporaryBirthDate?: Maybe<Scalars['Boolean']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  work?: Maybe<ProfileWork>;
  zodiac?: Maybe<Zodiac>;
};

export type ProfileInput = {
  alcohol?: InputMaybe<AlcoholHabit>;
  beard?: InputMaybe<Beard>;
  birthDate?: InputMaybe<Scalars['DateTime']['input']>;
  describeYourself?: InputMaybe<Scalars['String']['input']>;
  etnicity?: InputMaybe<Etnicity>;
  eyeColor?: InputMaybe<EyeColor>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  funFacts?: InputMaybe<Array<Scalars['String']['input']>>;
  gender?: InputMaybe<Gender>;
  hairColor?: InputMaybe<HairColor>;
  hereTo?: InputMaybe<HereTo>;
  interests?: InputMaybe<Array<Interest>>;
  kids?: InputMaybe<KidsStatus>;
  languages?: InputMaybe<Array<Language>>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  length?: InputMaybe<Scalars['Int']['input']>;
  living?: InputMaybe<Living>;
  location?: InputMaybe<ProfileLocationInput>;
  lookingFor?: InputMaybe<Array<Gender>>;
  mood?: InputMaybe<Scalars['String']['input']>;
  personality?: InputMaybe<Array<PersonalityTrait>>;
  relationshipStatus?: InputMaybe<RelationshipStatus>;
  religion?: InputMaybe<Religion>;
  sexuality?: InputMaybe<Sexuality>;
  smoking?: InputMaybe<SmokingHabit>;
  tattoo?: InputMaybe<Tattoo>;
  weight?: InputMaybe<Scalars['Int']['input']>;
  work?: InputMaybe<ProfileWorkInput>;
  zodiac?: InputMaybe<Zodiac>;
};

export type ProfileLocation = {
  __typename?: 'ProfileLocation';
  _id: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  county?: Maybe<Scalars['String']['output']>;
  geo?: Maybe<Geo>;
};

export type ProfileLocationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  country?: InputMaybe<Scalars['String']['input']>;
  county?: InputMaybe<Scalars['String']['input']>;
  geo?: InputMaybe<GeoInput>;
};

export type ProfilePhotosApprovalArgs = {
  fromDate: Scalars['DateTime']['input'];
  toDate: Scalars['DateTime']['input'];
};

/** English translations of the free-text profile fields, null when empty. */
export type ProfileTranslation = {
  __typename?: 'ProfileTranslation';
  describeYourself?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

export type ProfileWork = {
  __typename?: 'ProfileWork';
  _id: Scalars['String']['output'];
  company?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type ProfileWorkInput = {
  company?: InputMaybe<Scalars['String']['input']>;
  education?: InputMaybe<Scalars['String']['input']>;
  title?: InputMaybe<Scalars['String']['input']>;
};

export type PublicPhotosArgs = {
  fromDate: Scalars['DateTime']['input'];
  paging: PagingArgs;
  toDate: Scalars['DateTime']['input'];
};

export type Query = {
  __typename?: 'Query';
  _?: Maybe<Scalars['Boolean']['output']>;
  aiBotUsers: Array<AiBotUser>;
  analytics?: Maybe<AnalyticsResult>;
  attachmentUploads?: Maybe<PagedPhotos>;
  chat?: Maybe<Chat>;
  chatBetweenUsers?: Maybe<Chat>;
  chats: PagedChats;
  dashboard?: Maybe<DashboardData>;
  deletedUsers?: Maybe<Array<DeletedUser>>;
  getActiveLiveStreams: PagedLiveStreams;
  getLiveStream?: Maybe<LiveStream>;
  groupPhotos: Array<Group>;
  groups: Array<Group>;
  hello?: Maybe<Scalars['String']['output']>;
  matchVideosApproval?: Maybe<Array<User>>;
  onboardingHistory: OnboardingHistoryData;
  onboardingStats: OnboardingResult;
  paidConversion: PaidConversionResult;
  photoVerifications?: Maybe<Array<PhotoVerification>>;
  privatePhotos?: Maybe<PagedPhotos>;
  privateVideos?: Maybe<PagedVideos>;
  profilePhotosApproval?: Maybe<Array<User>>;
  publicPostsPendingReview?: Maybe<Array<Post>>;
  reelComments: PagedReelComments;
  reelWithComments: ReelWithComments;
  reelsApproval: ReelsApprovalResult;
  signupFlow: SignupFlowResult;
  subscriptions?: Maybe<SubscriptionsResult>;
  supportTicket?: Maybe<SupportTicket>;
  supportTicketCounts: SupportTicketCounts;
  supportTickets: PagedSupportTickets;
  survey: SurveyData;
  surveyAnalytics: SurveyAnalytics;
  surveyTextAnswers: Array<TextAnswer>;
  surveys: Array<SurveyListData>;
  translateProfile: ProfileTranslation;
  /** English translations of the ticket's subject and latest messages */
  translateSupportTicket: SupportTicketTranslation;
  unverifiedPhotos?: Maybe<PagedPhotos>;
  unverifiedVideos?: Maybe<PagedVideos>;
  user?: Maybe<User>;
  userActivityMap: UserActivityMapResult;
  userChats: PagedChats;
  userDiamondStatus: UserDiamondStatus;
  users: PagedUsers;
  verifiedPhotos?: Maybe<PagedPhotos>;
  videoChatHistory: VideoChatHistory;
  videoChatStatus: VideoChatStatus;
  voiceRecordings?: Maybe<Array<User>>;
};


export type QueryAttachmentUploadsArgs = {
  paging: PagingArgs;
};


export type QueryChatArgs = {
  _id: Scalars['String']['input'];
  userId?: InputMaybe<Scalars['String']['input']>;
};


export type QueryChatBetweenUsersArgs = {
  userId1: Scalars['String']['input'];
  userId2: Scalars['String']['input'];
};


export type QueryChatsArgs = {
  filter?: InputMaybe<ChatFilterInput>;
  paging: PagingArgs;
};


export type QueryGetActiveLiveStreamsArgs = {
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QueryGetLiveStreamArgs = {
  streamId: Scalars['String']['input'];
};


export type QueryOnboardingHistoryArgs = {
  args: OnboardingHistoryArgs;
};


export type QueryOnboardingStatsArgs = {
  args: OnboardingArgs;
};


export type QueryPaidConversionArgs = {
  args: PaidConversionArgs;
};


export type QueryPrivatePhotosArgs = {
  paging: PagingArgs;
};


export type QueryPrivateVideosArgs = {
  paging: PagingArgs;
};


export type QueryProfilePhotosApprovalArgs = {
  args: ProfilePhotosApprovalArgs;
};


export type QueryReelCommentsArgs = {
  paging: PagingArgs;
};


export type QueryReelWithCommentsArgs = {
  reelId: Scalars['String']['input'];
};


export type QueryReelsApprovalArgs = {
  args: ReelsApprovalArgs;
};


export type QuerySignupFlowArgs = {
  args: SignupFlowArgs;
};


export type QuerySubscriptionsArgs = {
  args: SubscriptionsArgs;
};


export type QuerySupportTicketArgs = {
  _id: Scalars['String']['input'];
};


export type QuerySupportTicketsArgs = {
  filter?: InputMaybe<SupportTicketFilterInput>;
  limit: Scalars['Int']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
};


export type QuerySurveyArgs = {
  _id: Scalars['String']['input'];
};


export type QuerySurveyAnalyticsArgs = {
  _id: Scalars['String']['input'];
};


export type QuerySurveyTextAnswersArgs = {
  _id: Scalars['String']['input'];
  questionIndex: Scalars['Int']['input'];
};


export type QueryTranslateProfileArgs = {
  userId: Scalars['String']['input'];
};


export type QueryTranslateSupportTicketArgs = {
  _id: Scalars['String']['input'];
};


export type QueryUnverifiedPhotosArgs = {
  args: PublicPhotosArgs;
};


export type QueryUnverifiedVideosArgs = {
  paging: PagingArgs;
};


export type QueryUserArgs = {
  _id: Scalars['String']['input'];
};


export type QueryUserActivityMapArgs = {
  args: UserActivityMapArgs;
};


export type QueryUserChatsArgs = {
  paging: PagingArgs;
  userId: Scalars['String']['input'];
};


export type QueryUserDiamondStatusArgs = {
  userId: Scalars['String']['input'];
};


export type QueryUsersArgs = {
  paging: PagingArgs;
  regex?: InputMaybe<Scalars['String']['input']>;
};


export type QueryVerifiedPhotosArgs = {
  paging: PagingArgs;
};


export type QueryVideoChatHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export type QuestionAnalytics = {
  __typename?: 'QuestionAnalytics';
  choiceAnalytics: Array<ChoiceAnalytics>;
  questionIndex: Scalars['Int']['output'];
  text: Scalars['String']['output'];
  totalAnswers: Scalars['Int']['output'];
  type: Scalars['String']['output'];
};

export type QuestionData = {
  __typename?: 'QuestionData';
  choices: Array<Maybe<ChoiceData>>;
  text: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type Reel = {
  __typename?: 'Reel';
  _id: Scalars['String']['output'];
  byUserId: Scalars['String']['output'];
  callToAction?: Maybe<Scalars['String']['output']>;
  callToActionButtonColor?: Maybe<Scalars['String']['output']>;
  callToActionButtonDelayMs?: Maybe<Scalars['Int']['output']>;
  callToActionType?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  explicit?: Maybe<Scalars['Boolean']['output']>;
  /**
   * If MediaConvert failed to transcode this HLS reel, the error message
   * is stored here. Set by video-pipeline/jobStatusHandler on MC ERROR.
   */
  hlsError?: Maybe<Scalars['String']['output']>;
  /**
   * True when the reel has been transcoded through the HLS pipeline
   * (video-pipeline project). Admins can use this to distinguish HLS reels
   * from legacy MP4 reels in the approval page.
   */
  hlsReady?: Maybe<Scalars['Boolean']['output']>;
  matchVideo: Scalars['Boolean']['output'];
  premium?: Maybe<Scalars['Boolean']['output']>;
  profilePhotoUrl?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<Scalars['String']['output']>>;
  thumbnailBlurhash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uploadComplete: Scalars['Boolean']['output'];
  uploadId: Scalars['String']['output'];
  url: Scalars['String']['output'];
  views: Scalars['Int']['output'];
};

export type ReelComment = {
  __typename?: 'ReelComment';
  _id: Scalars['String']['output'];
  byUserId: Scalars['String']['output'];
  byUserProfilePhotoUrl?: Maybe<Scalars['String']['output']>;
  byUsername?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  reelId: Scalars['String']['output'];
  reelThumbnailUrl?: Maybe<Scalars['String']['output']>;
  text: Scalars['String']['output'];
};

export enum ReelRejectReason {
  DoesNotMatchProfile = 'DoesNotMatchProfile',
  DoesNotShowYourself = 'DoesNotShowYourself',
  Duplicate = 'Duplicate',
  Inappropriate = 'Inappropriate',
  None = 'None',
  NotPortraitFormat = 'NotPortraitFormat',
  PoorQuality = 'PoorQuality',
  StillImagesNotAllowed = 'StillImagesNotAllowed',
  TooShort = 'TooShort',
  Underage = 'Underage'
}

export type ReelWithComments = {
  __typename?: 'ReelWithComments';
  comments: Array<ReelComment>;
  reel: Reel;
};

export type ReelsApprovalArgs = {
  search?: InputMaybe<Scalars['String']['input']>;
  sort: ReelsApprovalSort;
};

export type ReelsApprovalResult = {
  __typename?: 'ReelsApprovalResult';
  reels: Array<Reel>;
  searchedReels: Array<Reel>;
};

export enum ReelsApprovalSort {
  MostLiked = 'MostLiked',
  MostViewed = 'MostViewed',
  Newest = 'Newest'
}

export enum RelationshipStatus {
  Complicated = 'COMPLICATED',
  InOpenRelationship = 'IN_OPEN_RELATIONSHIP',
  InRelationship = 'IN_RELATIONSHIP',
  Married = 'MARRIED',
  Other = 'OTHER',
  Single = 'SINGLE',
  Undisclosed = 'UNDISCLOSED'
}

export enum Religion {
  Agnostic = 'Agnostic',
  Atheist = 'Atheist',
  Buddhist = 'Buddhist',
  Catholic = 'Catholic',
  Christian = 'Christian',
  Hindu = 'Hindu',
  Jain = 'Jain',
  Jewish = 'Jewish',
  Muslim = 'Muslim',
  Other = 'Other',
  Parsi = 'Parsi',
  Sikh = 'Sikh',
  Spiritual = 'Spiritual',
  Undisclosed = 'UNDISCLOSED'
}

export type Report = {
  __typename?: 'Report';
  _id: Scalars['String']['output'];
  byUserId?: Maybe<Scalars['String']['output']>;
  contentId?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['DateTime']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  problem?: Maybe<ReportProblem>;
  resolved?: Maybe<Scalars['Boolean']['output']>;
  resolvedByEmail?: Maybe<Scalars['String']['output']>;
  resolvedDate?: Maybe<Scalars['DateTime']['output']>;
  type?: Maybe<ReportType>;
};

export enum ReportProblem {
  Bullying = 'BULLYING',
  Harassment = 'HARASSMENT',
  HateSpeech = 'HATE_SPEECH',
  IntelectualProperty = 'INTELECTUAL_PROPERTY',
  Nudity = 'NUDITY',
  PrivacyViolation = 'PRIVACY_VIOLATION',
  Scam = 'SCAM',
  SelfInjury = 'SELF_INJURY',
  SexualServices = 'SEXUAL_SERVICES',
  Spam = 'SPAM',
  Terrorism = 'TERRORISM',
  Violence = 'VIOLENCE'
}

export enum ReportType {
  Comment = 'COMMENT',
  Group = 'GROUP',
  Live = 'LIVE',
  Message = 'MESSAGE',
  Post = 'POST',
  Reel = 'REEL',
  User = 'USER'
}

export type SendMessageToChatArgs = {
  chatId: Scalars['String']['input'];
  text?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
};

export type SendPushArgs = {
  actionUrl?: InputMaybe<Scalars['String']['input']>;
  message: Scalars['String']['input'];
  title: Scalars['String']['input'];
  userId: Scalars['String']['input'];
};

export enum Sexuality {
  AskMe = 'ASK_ME',
  Bisexual = 'BISEXUAL',
  Hetero = 'HETERO',
  Homo = 'HOMO',
  Other = 'OTHER',
  Undisclosed = 'UNDISCLOSED'
}

export type SignupFlowArgs = {
  fromDate: Scalars['DateTime']['input'];
  platform?: InputMaybe<Scalars['String']['input']>;
  toDate: Scalars['DateTime']['input'];
};

export type SignupFlowResult = {
  __typename?: 'SignupFlowResult';
  premiumPurchased: Scalars['Int']['output'];
  stepCompleted: Scalars['Int']['output'];
  stepOnboarding1: Scalars['Int']['output'];
  stepOnboarding1Active: Scalars['Int']['output'];
  stepOnboarding2: Scalars['Int']['output'];
  stepOnboarding2Active: Scalars['Int']['output'];
  stepOnboarding3: Scalars['Int']['output'];
  stepOnboarding3Active: Scalars['Int']['output'];
  stepOnboardingPaywall: Scalars['Int']['output'];
  stepOnboardingPaywallActive: Scalars['Int']['output'];
  totalUsers: Scalars['Int']['output'];
};

export enum SmokingHabit {
  HateSmoking = 'HATE_SMOKING',
  No = 'NO',
  Undisclosed = 'UNDISCLOSED',
  YesEveryDay = 'YES_EVERY_DAY',
  YesParties = 'YES_PARTIES',
  YesSometimes = 'YES_SOMETIMES'
}

export type SubscriptionCountryData = {
  __typename?: 'SubscriptionCountryData';
  count: Scalars['Int']['output'];
  country: Scalars['String']['output'];
};

export type SubscriptionData = {
  __typename?: 'SubscriptionData';
  active: Scalars['Boolean']['output'];
  age: Scalars['Int']['output'];
  country: Scalars['String']['output'];
  expireDate?: Maybe<Scalars['DateTime']['output']>;
  trial: Scalars['Boolean']['output'];
  userId: Scalars['String']['output'];
};

export type SubscriptionSourceData = {
  __typename?: 'SubscriptionSourceData';
  count: Scalars['Int']['output'];
  source: Scalars['String']['output'];
};

export type SubscriptionsAnalyticData = {
  __typename?: 'SubscriptionsAnalyticData';
  adAttributions: Array<AdAttributionData>;
  countries: Array<SubscriptionCountryData>;
  sources: Array<SubscriptionSourceData>;
};

export type SubscriptionsArgs = {
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  showActiveOnly?: InputMaybe<Scalars['Boolean']['input']>;
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SubscriptionsResult = {
  __typename?: 'SubscriptionsResult';
  analyticData: SubscriptionsAnalyticData;
  data?: Maybe<Array<SubscriptionData>>;
  totalSubscriptions?: Maybe<Scalars['Int']['output']>;
  totalSubscriptionsLast30days?: Maybe<Scalars['Int']['output']>;
  totalTrials?: Maybe<Scalars['Int']['output']>;
};

export type SupportAttachment = {
  __typename?: 'SupportAttachment';
  mime: Scalars['String']['output'];
  name: Scalars['String']['output'];
  size: Scalars['Int']['output'];
};

export type SupportMessage = {
  __typename?: 'SupportMessage';
  _id: Scalars['String']['output'];
  attachments: Array<SupportAttachment>;
  autoSubmitted: Scalars['Boolean']['output'];
  bounced: Scalars['Boolean']['output'];
  /** inbound | outbound */
  direction: Scalars['String']['output'];
  fromName?: Maybe<Scalars['String']['output']>;
  /** Inbound only: the whole mail, when it holds more than text */
  fullText?: Maybe<Scalars['String']['output']>;
  /** Chat tickets: older context copied in when the ticket was created */
  historical: Scalars['Boolean']['output'];
  /** Outbound only: sent | failed | skipped, when the reply was also posted in the app chat */
  inAppStatus?: Maybe<Scalars['String']['output']>;
  receivedAt: Scalars['DateTime']['output'];
  /** Outbound only: emil | auto */
  sentBy?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  /** The message without quoted replies and signatures */
  text: Scalars['String']['output'];
  /** Outbound only: desk | backoffice */
  via?: Maybe<Scalars['String']['output']>;
};

export type SupportMessageTranslation = {
  __typename?: 'SupportMessageTranslation';
  messageId: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SupportTicket = {
  __typename?: 'SupportTicket';
  _id: Scalars['String']['output'];
  autoReplyCount: Scalars['Int']['output'];
  blockedSender: Scalars['Boolean']['output'];
  category?: Maybe<Scalars['String']['output']>;
  /** chat for tickets answered inside the app, email for everything else */
  channel: Scalars['String']['output'];
  created: Scalars['DateTime']['output'];
  /** MG-<number> */
  displayId: Scalars['String']['output'];
  firstInboundAt: Scalars['DateTime']['output'];
  hasAttachments: Scalars['Boolean']['output'];
  inboundCount: Scalars['Int']['output'];
  language?: Maybe<Scalars['String']['output']>;
  lastInboundAt: Scalars['DateTime']['output'];
  lastOutboundAt?: Maybe<Scalars['DateTime']['output']>;
  messageCount: Scalars['Int']['output'];
  /** Oldest first, at most the latest 200 */
  messages: Array<SupportMessage>;
  /** Open, and an agent parked it for a human */
  needsAdmin: Scalars['Boolean']['output'];
  notes: Array<SupportTicketNote>;
  number: Scalars['Int']['output'];
  /** List only: the start of the latest message */
  preview?: Maybe<Scalars['String']['output']>;
  /** List only: inbound | outbound, the direction of the latest message */
  previewDirection?: Maybe<Scalars['String']['output']>;
  report?: Maybe<SupportTicketReport>;
  resolution?: Maybe<SupportTicketResolution>;
  senderEmail: Scalars['String']['output'];
  senderName: Scalars['String']['output'];
  snoozedUntil?: Maybe<Scalars['DateTime']['output']>;
  /** email | app_contact | app_report | app_chat | app_live_application | system */
  source: Scalars['String']['output'];
  spamReasons: Array<Scalars['String']['output']>;
  spamScore: Scalars['Float']['output'];
  /** open | waiting_user | resolved | spam | archived */
  status: Scalars['String']['output'];
  subject: Scalars['String']['output'];
  updated: Scalars['DateTime']['output'];
  user?: Maybe<SupportTicketUser>;
  userId?: Maybe<Scalars['String']['output']>;
};

export type SupportTicketCounts = {
  __typename?: 'SupportTicketCounts';
  archived: Scalars['Int']['output'];
  needsAdmin: Scalars['Int']['output'];
  /** Open and not snoozed */
  open: Scalars['Int']['output'];
  resolved: Scalars['Int']['output'];
  snoozed: Scalars['Int']['output'];
  spam: Scalars['Int']['output'];
  waitingUser: Scalars['Int']['output'];
};

export type SupportTicketFilterInput = {
  needsAdmin?: InputMaybe<Scalars['Boolean']['input']>;
  /** Ticket number (MG-1042 or 1042), ticket or user id, sender email, or words in the subject or sender name */
  search?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
  /** open | snoozed | waiting_user | resolved | spam | archived | all (default open) */
  status?: InputMaybe<Scalars['String']['input']>;
};

export type SupportTicketNote = {
  __typename?: 'SupportTicketNote';
  at: Scalars['DateTime']['output'];
  /** emil | agent | auto | ingest */
  by: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type SupportTicketReport = {
  __typename?: 'SupportTicketReport';
  contentId?: Maybe<Scalars['String']['output']>;
  problem: Scalars['String']['output'];
  reportedUserId?: Maybe<Scalars['String']['output']>;
  reportedUsername?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type SupportTicketResolution = {
  __typename?: 'SupportTicketResolution';
  at: Scalars['DateTime']['output'];
  by: Scalars['String']['output'];
  note?: Maybe<Scalars['String']['output']>;
};

export type SupportTicketTranslation = {
  __typename?: 'SupportTicketTranslation';
  messages: Array<SupportMessageTranslation>;
  subject?: Maybe<Scalars['String']['output']>;
};

export type SupportTicketUser = {
  __typename?: 'SupportTicketUser';
  _id: Scalars['String']['output'];
  banned: Scalars['Boolean']['output'];
  country?: Maybe<Scalars['String']['output']>;
  deleted: Scalars['Boolean']['output'];
  language?: Maybe<Scalars['String']['output']>;
  premium: Scalars['Boolean']['output'];
  username?: Maybe<Scalars['String']['output']>;
};

export type SurveyAnalytics = {
  __typename?: 'SurveyAnalytics';
  _id: Scalars['String']['output'];
  description: Scalars['String']['output'];
  questionAnalytics: Array<QuestionAnalytics>;
  title: Scalars['String']['output'];
  totalAnswers: Scalars['Int']['output'];
};

export type SurveyData = {
  __typename?: 'SurveyData';
  _id: Scalars['String']['output'];
  description: Scalars['String']['output'];
  questions: Array<QuestionData>;
  title: Scalars['String']['output'];
  totalAnswers: Scalars['Int']['output'];
};

export type SurveyListData = {
  __typename?: 'SurveyListData';
  _id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  totalAnswers: Scalars['Int']['output'];
};

export enum Tattoo {
  Many = 'MANY',
  No = 'NO',
  One = 'ONE',
  Undisclosed = 'UNDISCLOSED'
}

export type TextAnswer = {
  __typename?: 'TextAnswer';
  _id: Scalars['String']['output'];
  answer: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  userId: Scalars['String']['output'];
};

export type TotalUsersCountryItem = {
  __typename?: 'TotalUsersCountryItem';
  country: Scalars['String']['output'];
  users: Scalars['Int']['output'];
};

export type TotalUsersItem = {
  __typename?: 'TotalUsersItem';
  date: Scalars['DateTime']['output'];
  users: Scalars['Int']['output'];
};

export type UploadField = {
  __typename?: 'UploadField';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type UploadPostInfo = {
  __typename?: 'UploadPostInfo';
  fields?: Maybe<Array<Maybe<UploadField>>>;
  fileName: Scalars['String']['output'];
  postUrl: Scalars['String']['output'];
};

export type User = {
  __typename?: 'User';
  _id: Scalars['String']['output'];
  admin?: Maybe<Scalars['Boolean']['output']>;
  appVersion: Scalars['String']['output'];
  banned?: Maybe<Scalars['Boolean']['output']>;
  bannedUntilDate?: Maybe<Scalars['DateTime']['output']>;
  country: Scalars['String']['output'];
  created?: Maybe<Scalars['DateTime']['output']>;
  credits?: Maybe<Scalars['Int']['output']>;
  deleted?: Maybe<Scalars['Boolean']['output']>;
  describeYourself?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  gender: Gender;
  lastActive?: Maybe<Scalars['DateTime']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  liveBan?: Maybe<Scalars['Boolean']['output']>;
  /** Latest 'become a live streamer' application, null if never applied. */
  liveStreamingApplication?: Maybe<LiveStreamingApplication>;
  /** May start live streams (trusted creators gate). */
  liveStreamingApproved?: Maybe<Scalars['Boolean']['output']>;
  liveStreamingApprovedBy?: Maybe<Scalars['String']['output']>;
  liveStreamingApprovedDate?: Maybe<Scalars['DateTime']['output']>;
  loginDate?: Maybe<Scalars['DateTime']['output']>;
  matchVideo?: Maybe<Video>;
  matchVideoApproved?: Maybe<Scalars['Boolean']['output']>;
  photos?: Maybe<Array<Photo>>;
  platform: Scalars['String']['output'];
  premium?: Maybe<Scalars['Boolean']['output']>;
  profilePhoto?: Maybe<Photo>;
  profilePhotoApproved?: Maybe<Scalars['Boolean']['output']>;
  profilePhotoAutoApprovedNeedReview?: Maybe<Scalars['Boolean']['output']>;
  pushAvailable?: Maybe<Scalars['Boolean']['output']>;
  storeFront?: Maybe<Scalars['String']['output']>;
  translationTokens?: Maybe<Scalars['Int']['output']>;
  username?: Maybe<Scalars['String']['output']>;
  voicePrompts?: Maybe<Array<VoicePrompt>>;
};

export enum UserActivityFilter {
  AdFree = 'AdFree',
  Android = 'Android',
  Ios = 'Ios',
  Men = 'Men',
  NewSignups = 'NewSignups',
  OldSignups = 'OldSignups',
  Premium = 'Premium',
  Women = 'Women'
}

export type UserActivityMapArgs = {
  filters: Array<UserActivityFilter>;
  includeSignupReady: Scalars['Boolean']['input'];
  includeSignups: Scalars['Boolean']['input'];
  minutes: Scalars['Int']['input'];
};

export type UserActivityMapData = {
  __typename?: 'UserActivityMapData';
  appPlatform: Scalars['String']['output'];
  birthDate?: Maybe<Scalars['DateTime']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  created: Scalars['DateTime']['output'];
  currentAppVersion: Scalars['String']['output'];
  lastActive: Scalars['DateTime']['output'];
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
  photo?: Maybe<Photo>;
  premium: Scalars['Boolean']['output'];
  storeFront?: Maybe<Scalars['String']['output']>;
  userId: Scalars['String']['output'];
  username: Scalars['String']['output'];
  vip: Scalars['Boolean']['output'];
};

export type UserActivityMapResult = {
  __typename?: 'UserActivityMapResult';
  data: Array<UserActivityMapData>;
};

export type UserDiamondStatus = {
  __typename?: 'UserDiamondStatus';
  currentDiamondHistory: Array<DiamondHistoryEntry>;
  currentDiamonds: Scalars['Int']['output'];
  totalEarned: Scalars['Int']['output'];
  totalPaid: Scalars['Int']['output'];
};

export type Video = {
  __typename?: 'Video';
  _id: Scalars['String']['output'];
  approved: Scalars['Boolean']['output'];
  isPrivate: Scalars['Boolean']['output'];
  thumbnailBlurhash?: Maybe<Scalars['String']['output']>;
  thumbnailUrl?: Maybe<Scalars['String']['output']>;
  uploadById?: Maybe<Scalars['String']['output']>;
  uploadComplete: Scalars['Boolean']['output'];
  uploadId: Scalars['String']['output'];
  url: Scalars['String']['output'];
  verified: Scalars['Boolean']['output'];
};

export type VideoChatConnectionQuality = {
  __typename?: 'VideoChatConnectionQuality';
  averageLatency?: Maybe<Scalars['Float']['output']>;
  packetsLost?: Maybe<Scalars['Int']['output']>;
  reconnections?: Maybe<Scalars['Int']['output']>;
};

export type VideoChatHistory = {
  __typename?: 'VideoChatHistory';
  sessions: Array<VideoChatHistorySession>;
  totalCount: Scalars['Int']['output'];
};

export type VideoChatHistorySession = {
  __typename?: 'VideoChatHistorySession';
  _id: Scalars['String']['output'];
  chatId?: Maybe<Scalars['String']['output']>;
  connectionQuality?: Maybe<VideoChatConnectionQuality>;
  createdAt: Scalars['String']['output'];
  durationSeconds: Scalars['Int']['output'];
  endReason?: Maybe<Scalars['String']['output']>;
  endedBy?: Maybe<Scalars['String']['output']>;
  messages: Array<VideoChatMessage>;
  participant1: VideoChatUser;
  participant1JoinedAt?: Maybe<Scalars['String']['output']>;
  participant1LeftAt?: Maybe<Scalars['String']['output']>;
  participant2: VideoChatUser;
  participant2JoinedAt?: Maybe<Scalars['String']['output']>;
  participant2LeftAt?: Maybe<Scalars['String']['output']>;
  sessionEndedAt: Scalars['String']['output'];
  sessionId: Scalars['String']['output'];
  sessionStartedAt: Scalars['String']['output'];
  status: Scalars['String']['output'];
  totalMessageCount: Scalars['Int']['output'];
  type: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
};

export type VideoChatMessage = {
  __typename?: 'VideoChatMessage';
  fromUserId: Scalars['String']['output'];
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
  timestamp: Scalars['String']['output'];
};

export type VideoChatSession = {
  __typename?: 'VideoChatSession';
  sessionDurationSeconds: Scalars['Int']['output'];
  user1: VideoChatUser;
  user2: VideoChatUser;
};

export type VideoChatStatus = {
  __typename?: 'VideoChatStatus';
  activeSearchersCount: Scalars['Int']['output'];
  activeSessions: Array<VideoChatSession>;
  activeSessionsCount: Scalars['Int']['output'];
};

export type VideoChatUser = {
  __typename?: 'VideoChatUser';
  _id: Scalars['String']['output'];
  photoThumbnailUrl?: Maybe<Scalars['String']['output']>;
  username: Scalars['String']['output'];
};

export type VideoThumbnailUploadArgs = {
  contentLength: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
  videoUploadId: Scalars['String']['input'];
};

export type VideoUploadArgs = {
  contentLength: Scalars['String']['input'];
  contentType: Scalars['String']['input'];
  fileName: Scalars['String']['input'];
};

export type VideoUploadResult = {
  __typename?: 'VideoUploadResult';
  uploadId: Scalars['String']['output'];
  uploadPostInfo: UploadPostInfo;
};

export type VoicePrompt = {
  __typename?: 'VoicePrompt';
  created: Scalars['DateTime']['output'];
  text: Scalars['String']['output'];
  uploadComplete: Scalars['Boolean']['output'];
  uploadId: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

export enum Zodiac {
  Aquarius = 'Aquarius',
  Aries = 'Aries',
  Cancer = 'Cancer',
  Capricornus = 'Capricornus',
  Gemini = 'Gemini',
  Leo = 'Leo',
  Libra = 'Libra',
  Pisces = 'Pisces',
  Sagittarius = 'Sagittarius',
  Scorpius = 'Scorpius',
  Taurus = 'Taurus',
  Undisclosed = 'UNDISCLOSED',
  Virgo = 'Virgo'
}



export type ResolverTypeWrapper<T> = Promise<T> | T;


export type ResolverWithResolve<TResult, TParent, TContext, TArgs> = {
  resolve: ResolverFn<TResult, TParent, TContext, TArgs>;
};
export type Resolver<TResult, TParent = {}, TContext = {}, TArgs = {}> = ResolverFn<TResult, TParent, TContext, TArgs> | ResolverWithResolve<TResult, TParent, TContext, TArgs>;

export type ResolverFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => Promise<TResult> | TResult;

export type SubscriptionSubscribeFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => AsyncIterable<TResult> | Promise<AsyncIterable<TResult>>;

export type SubscriptionResolveFn<TResult, TParent, TContext, TArgs> = (
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;

export interface SubscriptionSubscriberObject<TResult, TKey extends string, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<{ [key in TKey]: TResult }, TParent, TContext, TArgs>;
  resolve?: SubscriptionResolveFn<TResult, { [key in TKey]: TResult }, TContext, TArgs>;
}

export interface SubscriptionResolverObject<TResult, TParent, TContext, TArgs> {
  subscribe: SubscriptionSubscribeFn<any, TParent, TContext, TArgs>;
  resolve: SubscriptionResolveFn<TResult, any, TContext, TArgs>;
}

export type SubscriptionObject<TResult, TKey extends string, TParent, TContext, TArgs> =
  | SubscriptionSubscriberObject<TResult, TKey, TParent, TContext, TArgs>
  | SubscriptionResolverObject<TResult, TParent, TContext, TArgs>;

export type SubscriptionResolver<TResult, TKey extends string, TParent = {}, TContext = {}, TArgs = {}> =
  | ((...args: any[]) => SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>)
  | SubscriptionObject<TResult, TKey, TParent, TContext, TArgs>;

export type TypeResolveFn<TTypes, TParent = {}, TContext = {}> = (
  parent: TParent,
  context: TContext,
  info: GraphQLResolveInfo
) => Maybe<TTypes> | Promise<Maybe<TTypes>>;

export type IsTypeOfResolverFn<T = {}, TContext = {}> = (obj: T, context: TContext, info: GraphQLResolveInfo) => boolean | Promise<boolean>;

export type NextResolverFn<T> = () => Promise<T>;

export type DirectiveResolverFn<TResult = {}, TParent = {}, TContext = {}, TArgs = {}> = (
  next: NextResolverFn<TResult>,
  parent: TParent,
  args: TArgs,
  context: TContext,
  info: GraphQLResolveInfo
) => TResult | Promise<TResult>;



/** Mapping between all available schema types and the resolvers types */
export type ResolversTypes = {
  AdAttributionData: ResolverTypeWrapper<AdAttributionData>;
  AiBotUser: ResolverTypeWrapper<AiBotUser>;
  AlcoholHabit: AlcoholHabit;
  AnalyticsResult: ResolverTypeWrapper<AnalyticsResult>;
  AppVersionData: ResolverTypeWrapper<AppVersionData>;
  Attachment: ResolverTypeWrapper<Attachment>;
  Beard: Beard;
  Boolean: ResolverTypeWrapper<Scalars['Boolean']['output']>;
  Chat: ResolverTypeWrapper<Chat>;
  ChatFilterInput: ChatFilterInput;
  ChoiceAnalytics: ResolverTypeWrapper<ChoiceAnalytics>;
  ChoiceData: ResolverTypeWrapper<ChoiceData>;
  CursorQueryArgs: CursorQueryArgs;
  DashboardData: ResolverTypeWrapper<DashboardData>;
  DateTime: ResolverTypeWrapper<Scalars['DateTime']['output']>;
  DauItem: ResolverTypeWrapper<DauItem>;
  DeletedUser: ResolverTypeWrapper<DeletedUser>;
  DiamondHistoryEntry: ResolverTypeWrapper<DiamondHistoryEntry>;
  DiamondType: DiamondType;
  Etnicity: Etnicity;
  EyeColor: EyeColor;
  FileUploadArgs: FileUploadArgs;
  Float: ResolverTypeWrapper<Scalars['Float']['output']>;
  FunFact: FunFact;
  Gender: Gender;
  GenderDistribution: ResolverTypeWrapper<GenderDistribution>;
  Geo: ResolverTypeWrapper<Geo>;
  GeoInput: GeoInput;
  GeocodeResult: ResolverTypeWrapper<GeocodeResult>;
  Group: ResolverTypeWrapper<Group>;
  GroupPrivacy: GroupPrivacy;
  GroupStatus: GroupStatus;
  GroupVisibility: GroupVisibility;
  HairColor: HairColor;
  HereTo: HereTo;
  ID: ResolverTypeWrapper<Scalars['ID']['output']>;
  Int: ResolverTypeWrapper<Scalars['Int']['output']>;
  Interest: Interest;
  KidsStatus: KidsStatus;
  LIVING: Living;
  Language: Language;
  LanguageString: ResolverTypeWrapper<LanguageString>;
  LivePagingResult: ResolverTypeWrapper<LivePagingResult>;
  LiveStream: ResolverTypeWrapper<LiveStream>;
  LiveStreamStatus: LiveStreamStatus;
  LiveStreamUser: ResolverTypeWrapper<LiveStreamUser>;
  LiveStreamingApplication: ResolverTypeWrapper<LiveStreamingApplication>;
  Location: ResolverTypeWrapper<Location>;
  LocationInput: LocationInput;
  LoginResult: ResolverTypeWrapper<LoginResult>;
  MeetType: MeetType;
  MeetWhen: MeetWhen;
  MemberVisibility: MemberVisibility;
  Message: ResolverTypeWrapper<Message>;
  Mutation: ResolverTypeWrapper<{}>;
  OffsetQueryArgs: OffsetQueryArgs;
  OnboardingArgs: OnboardingArgs;
  OnboardingData: ResolverTypeWrapper<OnboardingData>;
  OnboardingHistoryArgs: OnboardingHistoryArgs;
  OnboardingHistoryData: ResolverTypeWrapper<OnboardingHistoryData>;
  OnboardingResult: ResolverTypeWrapper<OnboardingResult>;
  PageQueryArgs: PageQueryArgs;
  PagedChats: ResolverTypeWrapper<PagedChats>;
  PagedLiveStreams: ResolverTypeWrapper<PagedLiveStreams>;
  PagedMessages: ResolverTypeWrapper<PagedMessages>;
  PagedPhotos: ResolverTypeWrapper<PagedPhotos>;
  PagedReelComments: ResolverTypeWrapper<PagedReelComments>;
  PagedSupportTickets: ResolverTypeWrapper<PagedSupportTickets>;
  PagedUsers: ResolverTypeWrapper<PagedUsers>;
  PagedVideos: ResolverTypeWrapper<PagedVideos>;
  PagingArgs: PagingArgs;
  PagingResult: ResolverTypeWrapper<PagingResult>;
  PaidConversionArgs: PaidConversionArgs;
  PaidConversionResult: ResolverTypeWrapper<PaidConversionResult>;
  PaidConversionSourceData: ResolverTypeWrapper<PaidConversionSourceData>;
  PersonalityTrait: PersonalityTrait;
  Photo: ResolverTypeWrapper<Photo>;
  PhotoModeration: ResolverTypeWrapper<PhotoModeration>;
  PhotoRejectReason: PhotoRejectReason;
  PhotoUploadArgs: PhotoUploadArgs;
  PhotoUploadResult: ResolverTypeWrapper<PhotoUploadResult>;
  PhotoVerification: ResolverTypeWrapper<PhotoVerification>;
  PlaceAutocomplete: ResolverTypeWrapper<PlaceAutocomplete>;
  Post: ResolverTypeWrapper<Post>;
  PostAudience: PostAudience;
  PostReviewStatus: PostReviewStatus;
  Profile: ResolverTypeWrapper<Profile>;
  ProfileInput: ProfileInput;
  ProfileLocation: ResolverTypeWrapper<ProfileLocation>;
  ProfileLocationInput: ProfileLocationInput;
  ProfilePhotosApprovalArgs: ProfilePhotosApprovalArgs;
  ProfileTranslation: ResolverTypeWrapper<ProfileTranslation>;
  ProfileWork: ResolverTypeWrapper<ProfileWork>;
  ProfileWorkInput: ProfileWorkInput;
  PublicPhotosArgs: PublicPhotosArgs;
  Query: ResolverTypeWrapper<{}>;
  QuestionAnalytics: ResolverTypeWrapper<QuestionAnalytics>;
  QuestionData: ResolverTypeWrapper<QuestionData>;
  Reel: ResolverTypeWrapper<Reel>;
  ReelComment: ResolverTypeWrapper<ReelComment>;
  ReelRejectReason: ReelRejectReason;
  ReelWithComments: ResolverTypeWrapper<ReelWithComments>;
  ReelsApprovalArgs: ReelsApprovalArgs;
  ReelsApprovalResult: ResolverTypeWrapper<ReelsApprovalResult>;
  ReelsApprovalSort: ReelsApprovalSort;
  RelationshipStatus: RelationshipStatus;
  Religion: Religion;
  Report: ResolverTypeWrapper<Report>;
  ReportProblem: ReportProblem;
  ReportType: ReportType;
  SendMessageToChatArgs: SendMessageToChatArgs;
  SendPushArgs: SendPushArgs;
  Sexuality: Sexuality;
  SignupFlowArgs: SignupFlowArgs;
  SignupFlowResult: ResolverTypeWrapper<SignupFlowResult>;
  SmokingHabit: SmokingHabit;
  String: ResolverTypeWrapper<Scalars['String']['output']>;
  SubscriptionCountryData: ResolverTypeWrapper<SubscriptionCountryData>;
  SubscriptionData: ResolverTypeWrapper<SubscriptionData>;
  SubscriptionSourceData: ResolverTypeWrapper<SubscriptionSourceData>;
  SubscriptionsAnalyticData: ResolverTypeWrapper<SubscriptionsAnalyticData>;
  SubscriptionsArgs: SubscriptionsArgs;
  SubscriptionsResult: ResolverTypeWrapper<SubscriptionsResult>;
  SupportAttachment: ResolverTypeWrapper<SupportAttachment>;
  SupportMessage: ResolverTypeWrapper<SupportMessage>;
  SupportMessageTranslation: ResolverTypeWrapper<SupportMessageTranslation>;
  SupportTicket: ResolverTypeWrapper<SupportTicket>;
  SupportTicketCounts: ResolverTypeWrapper<SupportTicketCounts>;
  SupportTicketFilterInput: SupportTicketFilterInput;
  SupportTicketNote: ResolverTypeWrapper<SupportTicketNote>;
  SupportTicketReport: ResolverTypeWrapper<SupportTicketReport>;
  SupportTicketResolution: ResolverTypeWrapper<SupportTicketResolution>;
  SupportTicketTranslation: ResolverTypeWrapper<SupportTicketTranslation>;
  SupportTicketUser: ResolverTypeWrapper<SupportTicketUser>;
  SurveyAnalytics: ResolverTypeWrapper<SurveyAnalytics>;
  SurveyData: ResolverTypeWrapper<SurveyData>;
  SurveyListData: ResolverTypeWrapper<SurveyListData>;
  TATTOO: Tattoo;
  TextAnswer: ResolverTypeWrapper<TextAnswer>;
  TotalUsersCountryItem: ResolverTypeWrapper<TotalUsersCountryItem>;
  TotalUsersItem: ResolverTypeWrapper<TotalUsersItem>;
  UploadField: ResolverTypeWrapper<UploadField>;
  UploadPostInfo: ResolverTypeWrapper<UploadPostInfo>;
  User: ResolverTypeWrapper<User>;
  UserActivityFilter: UserActivityFilter;
  UserActivityMapArgs: UserActivityMapArgs;
  UserActivityMapData: ResolverTypeWrapper<UserActivityMapData>;
  UserActivityMapResult: ResolverTypeWrapper<UserActivityMapResult>;
  UserDiamondStatus: ResolverTypeWrapper<UserDiamondStatus>;
  Video: ResolverTypeWrapper<Video>;
  VideoChatConnectionQuality: ResolverTypeWrapper<VideoChatConnectionQuality>;
  VideoChatHistory: ResolverTypeWrapper<VideoChatHistory>;
  VideoChatHistorySession: ResolverTypeWrapper<VideoChatHistorySession>;
  VideoChatMessage: ResolverTypeWrapper<VideoChatMessage>;
  VideoChatSession: ResolverTypeWrapper<VideoChatSession>;
  VideoChatStatus: ResolverTypeWrapper<VideoChatStatus>;
  VideoChatUser: ResolverTypeWrapper<VideoChatUser>;
  VideoThumbnailUploadArgs: VideoThumbnailUploadArgs;
  VideoUploadArgs: VideoUploadArgs;
  VideoUploadResult: ResolverTypeWrapper<VideoUploadResult>;
  VoicePrompt: ResolverTypeWrapper<VoicePrompt>;
  Zodiac: Zodiac;
};

/** Mapping between all available schema types and the resolvers parents */
export type ResolversParentTypes = {
  AdAttributionData: AdAttributionData;
  AiBotUser: AiBotUser;
  AnalyticsResult: AnalyticsResult;
  AppVersionData: AppVersionData;
  Attachment: Attachment;
  Boolean: Scalars['Boolean']['output'];
  Chat: Chat;
  ChatFilterInput: ChatFilterInput;
  ChoiceAnalytics: ChoiceAnalytics;
  ChoiceData: ChoiceData;
  CursorQueryArgs: CursorQueryArgs;
  DashboardData: DashboardData;
  DateTime: Scalars['DateTime']['output'];
  DauItem: DauItem;
  DeletedUser: DeletedUser;
  DiamondHistoryEntry: DiamondHistoryEntry;
  FileUploadArgs: FileUploadArgs;
  Float: Scalars['Float']['output'];
  GenderDistribution: GenderDistribution;
  Geo: Geo;
  GeoInput: GeoInput;
  GeocodeResult: GeocodeResult;
  Group: Group;
  ID: Scalars['ID']['output'];
  Int: Scalars['Int']['output'];
  LanguageString: LanguageString;
  LivePagingResult: LivePagingResult;
  LiveStream: LiveStream;
  LiveStreamUser: LiveStreamUser;
  LiveStreamingApplication: LiveStreamingApplication;
  Location: Location;
  LocationInput: LocationInput;
  LoginResult: LoginResult;
  Message: Message;
  Mutation: {};
  OffsetQueryArgs: OffsetQueryArgs;
  OnboardingArgs: OnboardingArgs;
  OnboardingData: OnboardingData;
  OnboardingHistoryArgs: OnboardingHistoryArgs;
  OnboardingHistoryData: OnboardingHistoryData;
  OnboardingResult: OnboardingResult;
  PageQueryArgs: PageQueryArgs;
  PagedChats: PagedChats;
  PagedLiveStreams: PagedLiveStreams;
  PagedMessages: PagedMessages;
  PagedPhotos: PagedPhotos;
  PagedReelComments: PagedReelComments;
  PagedSupportTickets: PagedSupportTickets;
  PagedUsers: PagedUsers;
  PagedVideos: PagedVideos;
  PagingArgs: PagingArgs;
  PagingResult: PagingResult;
  PaidConversionArgs: PaidConversionArgs;
  PaidConversionResult: PaidConversionResult;
  PaidConversionSourceData: PaidConversionSourceData;
  Photo: Photo;
  PhotoModeration: PhotoModeration;
  PhotoUploadArgs: PhotoUploadArgs;
  PhotoUploadResult: PhotoUploadResult;
  PhotoVerification: PhotoVerification;
  PlaceAutocomplete: PlaceAutocomplete;
  Post: Post;
  Profile: Profile;
  ProfileInput: ProfileInput;
  ProfileLocation: ProfileLocation;
  ProfileLocationInput: ProfileLocationInput;
  ProfilePhotosApprovalArgs: ProfilePhotosApprovalArgs;
  ProfileTranslation: ProfileTranslation;
  ProfileWork: ProfileWork;
  ProfileWorkInput: ProfileWorkInput;
  PublicPhotosArgs: PublicPhotosArgs;
  Query: {};
  QuestionAnalytics: QuestionAnalytics;
  QuestionData: QuestionData;
  Reel: Reel;
  ReelComment: ReelComment;
  ReelWithComments: ReelWithComments;
  ReelsApprovalArgs: ReelsApprovalArgs;
  ReelsApprovalResult: ReelsApprovalResult;
  Report: Report;
  SendMessageToChatArgs: SendMessageToChatArgs;
  SendPushArgs: SendPushArgs;
  SignupFlowArgs: SignupFlowArgs;
  SignupFlowResult: SignupFlowResult;
  String: Scalars['String']['output'];
  SubscriptionCountryData: SubscriptionCountryData;
  SubscriptionData: SubscriptionData;
  SubscriptionSourceData: SubscriptionSourceData;
  SubscriptionsAnalyticData: SubscriptionsAnalyticData;
  SubscriptionsArgs: SubscriptionsArgs;
  SubscriptionsResult: SubscriptionsResult;
  SupportAttachment: SupportAttachment;
  SupportMessage: SupportMessage;
  SupportMessageTranslation: SupportMessageTranslation;
  SupportTicket: SupportTicket;
  SupportTicketCounts: SupportTicketCounts;
  SupportTicketFilterInput: SupportTicketFilterInput;
  SupportTicketNote: SupportTicketNote;
  SupportTicketReport: SupportTicketReport;
  SupportTicketResolution: SupportTicketResolution;
  SupportTicketTranslation: SupportTicketTranslation;
  SupportTicketUser: SupportTicketUser;
  SurveyAnalytics: SurveyAnalytics;
  SurveyData: SurveyData;
  SurveyListData: SurveyListData;
  TextAnswer: TextAnswer;
  TotalUsersCountryItem: TotalUsersCountryItem;
  TotalUsersItem: TotalUsersItem;
  UploadField: UploadField;
  UploadPostInfo: UploadPostInfo;
  User: User;
  UserActivityMapArgs: UserActivityMapArgs;
  UserActivityMapData: UserActivityMapData;
  UserActivityMapResult: UserActivityMapResult;
  UserDiamondStatus: UserDiamondStatus;
  Video: Video;
  VideoChatConnectionQuality: VideoChatConnectionQuality;
  VideoChatHistory: VideoChatHistory;
  VideoChatHistorySession: VideoChatHistorySession;
  VideoChatMessage: VideoChatMessage;
  VideoChatSession: VideoChatSession;
  VideoChatStatus: VideoChatStatus;
  VideoChatUser: VideoChatUser;
  VideoThumbnailUploadArgs: VideoThumbnailUploadArgs;
  VideoUploadArgs: VideoUploadArgs;
  VideoUploadResult: VideoUploadResult;
  VoicePrompt: VoicePrompt;
};

export type AdAttributionDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AdAttributionData'] = ResolversParentTypes['AdAttributionData']> = {
  adGroup?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  keyword?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  trial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AiBotUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['AiBotUser'] = ResolversParentTypes['AiBotUser']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastUnansweredMessageDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  profileImageUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AnalyticsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['AnalyticsResult'] = ResolversParentTypes['AnalyticsResult']> = {
  daus?: Resolver<Maybe<Array<ResolversTypes['DauItem']>>, ParentType, ContextType>;
  totalActiveUsersLast30days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalActiveUsersLast30daysCreatedMoreThan90daysAgo?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalFemaleUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalMaleUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalNewUsersLast30days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalOtherGenderUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPayingUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPayingUsersLast30days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsers?: Resolver<Maybe<Array<ResolversTypes['TotalUsersItem']>>, ParentType, ContextType>;
  totalUsersByCountry?: Resolver<Maybe<Array<ResolversTypes['TotalUsersCountryItem']>>, ParentType, ContextType>;
  totalUsersLoginApple?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsersLoginEmail?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsersLoginFacebook?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsersLoginGoogle?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsersPlatformAndroid?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsersPlatformIos?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsersPlatformWeb?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalUsersWithPremium?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalVerifiedUsers?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AppVersionDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['AppVersionData'] = ResolversParentTypes['AppVersionData']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  version?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type AttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['Attachment'] = ResolversParentTypes['Attachment']> = {
  blurhash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentType?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  expired?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChatResolvers<ContextType = any, ParentType extends ResolversParentTypes['Chat'] = ResolversParentTypes['Chat']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ended?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  endedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastMessage?: Resolver<Maybe<ResolversTypes['Message']>, ParentType, ContextType>;
  lastMessageId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  members?: Resolver<Maybe<Array<Maybe<ResolversTypes['User']>>>, ParentType, ContextType>;
  messages?: Resolver<Maybe<ResolversTypes['PagedMessages']>, ParentType, ContextType, RequireFields<ChatMessagesArgs, 'input'>>;
  updatedDate?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChoiceAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChoiceAnalytics'] = ResolversParentTypes['ChoiceAnalytics']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  percentage?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ChoiceDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['ChoiceData'] = ResolversParentTypes['ChoiceData']> = {
  label?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DashboardDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['DashboardData'] = ResolversParentTypes['DashboardData']> = {
  dailyActiveUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  monthlyActiveUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalBannedUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalGroups?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalInvites?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPrivatePhotos?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUnresolvedReports?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUnverifiedPhotos?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUnverifiedUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsersWithApprovedPhoto?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export interface DateTimeScalarConfig extends GraphQLScalarTypeConfig<ResolversTypes['DateTime'], any> {
  name: 'DateTime';
}

export type DauItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['DauItem'] = ResolversParentTypes['DauItem']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  mau?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  users?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DeletedUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['DeletedUser'] = ResolversParentTypes['DeletedUser']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  deletedReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deletedText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastActive?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type DiamondHistoryEntryResolvers<ContextType = any, ParentType extends ResolversParentTypes['DiamondHistoryEntry'] = ResolversParentTypes['DiamondHistoryEntry']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  diamondsEarned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  giftType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  qualifiedViews?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reelId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reelThumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['DiamondType'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GenderDistributionResolvers<ContextType = any, ParentType extends ResolversParentTypes['GenderDistribution'] = ResolversParentTypes['GenderDistribution']> = {
  femaleUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  maleUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  otherGenderUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Geo'] = ResolversParentTypes['Geo']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  coordinates?: Resolver<Maybe<Array<Maybe<ResolversTypes['Float']>>>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GeocodeResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['GeocodeResult'] = ResolversParentTypes['GeocodeResult']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type GroupResolvers<ContextType = any, ParentType extends ResolversParentTypes['Group'] = ResolversParentTypes['Group']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  about?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  genderLimited?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  maxAgeLimited?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  memberCommentsAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memberPostsAllowed?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  memberVisibility?: Resolver<ResolversTypes['MemberVisibility'], ParentType, ContextType>;
  minAgeLimited?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  photo?: Resolver<Maybe<ResolversTypes['Photo']>, ParentType, ContextType>;
  privacy?: Resolver<ResolversTypes['GroupPrivacy'], ParentType, ContextType>;
  rules?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  visibility?: Resolver<ResolversTypes['GroupVisibility'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LanguageStringResolvers<ContextType = any, ParentType extends ResolversParentTypes['LanguageString'] = ResolversParentTypes['LanguageString']> = {
  lang?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LivePagingResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LivePagingResult'] = ResolversParentTypes['LivePagingResult']> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDocs?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveStreamResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveStream'] = ResolversParentTypes['LiveStream']> = {
  _id?: Resolver<ResolversTypes['ID'], ParentType, ContextType>;
  allowComments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  allowGifts?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentViewerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  hostUser?: Resolver<ResolversTypes['LiveStreamUser'], ParentType, ContextType>;
  isPrivate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  peakViewerCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  startedAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['LiveStreamStatus'], ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  totalDiamondsEarned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveStreamUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveStreamUser'] = ResolversParentTypes['LiveStreamUser']> = {
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePhotoThumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  profilePhotoUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LiveStreamingApplicationResolvers<ContextType = any, ParentType extends ResolversParentTypes['LiveStreamingApplication'] = ResolversParentTypes['LiveStreamingApplication']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  decidedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  decidedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  reason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  retryAfterDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticketId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  ticketNumber?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Location'] = ResolversParentTypes['Location']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geo?: Resolver<Maybe<ResolversTypes['Geo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type LoginResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['LoginResult'] = ResolversParentTypes['LoginResult']> = {
  authenticated?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  token?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['Message'] = ResolversParentTypes['Message']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chatId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  fromId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  viewedByIds?: Resolver<Maybe<Array<Maybe<ResolversTypes['String']>>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type MutationResolvers<ContextType = any, ParentType extends ResolversParentTypes['Mutation'] = ResolversParentTypes['Mutation']> = {
  _?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  addSupportTicketNote?: Resolver<ResolversTypes['SupportTicket'], ParentType, ContextType, RequireFields<MutationAddSupportTicketNoteArgs, '_id' | 'text'>>;
  approveGroup?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApproveGroupArgs, 'groupId' | 'value'>>;
  approveGroupPhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApproveGroupPhotoArgs, 'groupId' | 'value'>>;
  approveMatchVideo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApproveMatchVideoArgs, 'userId' | 'value'>>;
  approvePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApprovePhotoArgs, 'uploadId' | 'value'>>;
  approvePhotoVerification?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApprovePhotoVerificationArgs, 'userId' | 'value'>>;
  approveProfilePhoto?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApproveProfilePhotoArgs, 'userId' | 'value'>>;
  approveReel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApproveReelArgs, 'explicit' | 'matchVideo' | 'reelId' | 'rejectReason' | 'value'>>;
  approveVideo?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationApproveVideoArgs, 'uploadId' | 'value'>>;
  banUserFromLiveStreaming?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationBanUserFromLiveStreamingArgs, 'streamId' | 'userId'>>;
  deleteReel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteReelArgs, 'reelId'>>;
  deleteReelComment?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationDeleteReelCommentArgs, 'commentId'>>;
  deleteUser?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteUserArgs, 'userId'>>;
  deleteVoiceRecording?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationDeleteVoiceRecordingArgs, 'uploadId' | 'userId'>>;
  endLiveStream?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationEndLiveStreamArgs, 'streamId'>>;
  fixMan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationFixManArgs, 'userId'>>;
  googleLogin?: Resolver<Maybe<ResolversTypes['LoginResult']>, ParentType, ContextType, RequireFields<MutationGoogleLoginArgs, 'captcha' | 'token'>>;
  markReelForHlsConvert?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationMarkReelForHlsConvertArgs, 'reelId'>>;
  promoteReel?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationPromoteReelArgs, 'reelId'>>;
  replySupportTicket?: Resolver<ResolversTypes['SupportTicket'], ParentType, ContextType, RequireFields<MutationReplySupportTicketArgs, '_id' | 'resolve' | 'text'>>;
  reviewPost?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationReviewPostArgs, 'postId' | 'reviewStatus'>>;
  sendMessage?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationSendMessageArgs, 'input'>>;
  sendPush?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSendPushArgs, 'args'>>;
  setBan?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSetBanArgs, '_id' | 'value'>>;
  setLiveBan?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetLiveBanArgs, 'userId' | 'value'>>;
  setLiveStreamingApproved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType, RequireFields<MutationSetLiveStreamingApprovedArgs, 'userId' | 'value'>>;
  setReelDescription?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSetReelDescriptionArgs, 'description' | 'reelId'>>;
  setReelExplicit?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType, RequireFields<MutationSetReelExplicitArgs, 'explicit' | 'reelId'>>;
  setSupportTicketStatus?: Resolver<ResolversTypes['SupportTicket'], ParentType, ContextType, RequireFields<MutationSetSupportTicketStatusArgs, '_id' | 'status'>>;
  uploadReelThumbnail?: Resolver<Maybe<ResolversTypes['PhotoUploadResult']>, ParentType, ContextType, RequireFields<MutationUploadReelThumbnailArgs, 'contentLength' | 'contentType' | 'fileName' | 'reelId'>>;
  viewChat?: Resolver<ResolversTypes['String'], ParentType, ContextType, RequireFields<MutationViewChatArgs, 'chatId'>>;
};

export type OnboardingDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingData'] = ResolversParentTypes['OnboardingData']> = {
  appVersions?: Resolver<Array<ResolversTypes['AppVersionData']>, ParentType, ContextType>;
  atAuth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  atMatch?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  atPreferences?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  atReady?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  femaleFinishedOnboarding?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  inviteCodesUsed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  newPremium1Week?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  newPremium3Months?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  photoFinishedOnboarding?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  platform?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  pushFinishedOnboarding?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  renewalPremium1Week?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  renewalPremium3Months?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  subscriptionSources?: Resolver<Array<ResolversTypes['SubscriptionSourceData']>, ParentType, ContextType>;
  totalActiveInviteCodes?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalBoostIap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalFinishedOnboarding?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalHotLikesIap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalIapUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalLiveGiftIap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPremiumOnboarding?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPremiumUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPushActivated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalRewardedAdsWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSpotlightIap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUnlockChatIap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalVotesIap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalWinksIap?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  userCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingHistoryDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingHistoryData'] = ResolversParentTypes['OnboardingHistoryData']> = {
  onboardingData?: Resolver<Array<ResolversTypes['OnboardingData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type OnboardingResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['OnboardingResult'] = ResolversParentTypes['OnboardingResult']> = {
  activeAtAuth?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  activeAtMatch?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  activeAtMatchingPreferences?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  activeAtReady?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  atAuth?: Resolver<ResolversTypes['GenderDistribution'], ParentType, ContextType>;
  atMatch?: Resolver<ResolversTypes['GenderDistribution'], ParentType, ContextType>;
  atMatchingPreferences?: Resolver<ResolversTypes['GenderDistribution'], ParentType, ContextType>;
  atReady?: Resolver<ResolversTypes['GenderDistribution'], ParentType, ContextType>;
  finishedOnboarding?: Resolver<ResolversTypes['GenderDistribution'], ParentType, ContextType>;
  finishedOnboardingWithLocation?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  finishedOnboardingWithPhoto?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  finishedOnboardingWithPhotoFemale?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  finishedOnboardingWithPhotoMale?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  premiumOnboarding?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  premiumTotal?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  premiumWithoutFlag?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalDistribution?: Resolver<ResolversTypes['GenderDistribution'], ParentType, ContextType>;
  totalPushActivated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalRewardedAdsWatched?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedChatsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedChats'] = ResolversParentTypes['PagedChats']> = {
  nodes?: Resolver<Array<ResolversTypes['Chat']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedLiveStreamsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedLiveStreams'] = ResolversParentTypes['PagedLiveStreams']> = {
  nodes?: Resolver<Array<ResolversTypes['LiveStream']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['LivePagingResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedMessagesResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedMessages'] = ResolversParentTypes['PagedMessages']> = {
  nodes?: Resolver<Array<ResolversTypes['Message']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedPhotosResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedPhotos'] = ResolversParentTypes['PagedPhotos']> = {
  nodes?: Resolver<Array<ResolversTypes['Photo']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedReelCommentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedReelComments'] = ResolversParentTypes['PagedReelComments']> = {
  nodes?: Resolver<Array<ResolversTypes['ReelComment']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedSupportTicketsResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedSupportTickets'] = ResolversParentTypes['PagedSupportTickets']> = {
  hasNextPage?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  limit?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  nodes?: Resolver<Array<ResolversTypes['SupportTicket']>, ParentType, ContextType>;
  offset?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  total?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedUsersResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedUsers'] = ResolversParentTypes['PagedUsers']> = {
  nodes?: Resolver<Array<ResolversTypes['User']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagedVideosResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagedVideos'] = ResolversParentTypes['PagedVideos']> = {
  nodes?: Resolver<Array<ResolversTypes['Video']>, ParentType, ContextType>;
  paging?: Resolver<ResolversTypes['PagingResult'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PagingResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PagingResult'] = ResolversParentTypes['PagingResult']> = {
  hasNextPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hasPrevPage?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  limit?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  nextPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  offset?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  page?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  pagingCounter?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  prevPage?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  total?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalPages?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaidConversionResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaidConversionResult'] = ResolversParentTypes['PaidConversionResult']> = {
  purchasesFromExistingUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  sources?: Resolver<Array<ResolversTypes['PaidConversionSourceData']>, ParentType, ContextType>;
  totalOnboardingFinished?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalSubscriptions?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsersCreated?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PaidConversionSourceDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['PaidConversionSourceData'] = ResolversParentTypes['PaidConversionSourceData']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhotoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Photo'] = ResolversParentTypes['Photo']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  approved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  blurhash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  isPrivate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  moderation?: Resolver<Maybe<ResolversTypes['PhotoModeration']>, ParentType, ContextType>;
  platform?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadById?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhotoModerationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhotoModeration'] = ResolversParentTypes['PhotoModeration']> = {
  ageRangeHigh?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  ageRangeLow?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  celebrityConfidence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  celebrityName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  checkedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  faceCount?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genderConfidence?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  genderDetected?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  graphicsLabels?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  moderationLabels?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  outcome?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  rejectReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reviewReasons?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhotoUploadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhotoUploadResult'] = ResolversParentTypes['PhotoUploadResult']> = {
  uploadId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadPostInfo?: Resolver<ResolversTypes['UploadPostInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PhotoVerificationResolvers<ContextType = any, ParentType extends ResolversParentTypes['PhotoVerification'] = ResolversParentTypes['PhotoVerification']> = {
  profilePhoto?: Resolver<ResolversTypes['Photo'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verifyPhoto?: Resolver<ResolversTypes['Photo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PlaceAutocompleteResolvers<ContextType = any, ParentType extends ResolversParentTypes['PlaceAutocomplete'] = ResolversParentTypes['PlaceAutocomplete']> = {
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geo?: Resolver<Maybe<ResolversTypes['Geo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type PostResolvers<ContextType = any, ParentType extends ResolversParentTypes['Post'] = ResolversParentTypes['Post']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attachments?: Resolver<Maybe<Array<ResolversTypes['Attachment']>>, ParentType, ContextType>;
  audience?: Resolver<ResolversTypes['PostAudience'], ParentType, ContextType>;
  byUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  reviewStatus?: Resolver<ResolversTypes['PostReviewStatus'], ParentType, ContextType>;
  text?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileResolvers<ContextType = any, ParentType extends ResolversParentTypes['Profile'] = ResolversParentTypes['Profile']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  alcohol?: Resolver<Maybe<ResolversTypes['AlcoholHabit']>, ParentType, ContextType>;
  beard?: Resolver<Maybe<ResolversTypes['Beard']>, ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  birthDateChanged?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  describeYourself?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  etnicity?: Resolver<Maybe<ResolversTypes['Etnicity']>, ParentType, ContextType>;
  eyeColor?: Resolver<Maybe<ResolversTypes['EyeColor']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  funFacts?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  gender?: Resolver<Maybe<ResolversTypes['Gender']>, ParentType, ContextType>;
  hairColor?: Resolver<Maybe<ResolversTypes['HairColor']>, ParentType, ContextType>;
  hereTo?: Resolver<Maybe<ResolversTypes['HereTo']>, ParentType, ContextType>;
  interests?: Resolver<Maybe<Array<ResolversTypes['Interest']>>, ParentType, ContextType>;
  kids?: Resolver<Maybe<ResolversTypes['KidsStatus']>, ParentType, ContextType>;
  languages?: Resolver<Maybe<Array<ResolversTypes['Language']>>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  length?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  living?: Resolver<Maybe<ResolversTypes['LIVING']>, ParentType, ContextType>;
  location?: Resolver<Maybe<ResolversTypes['ProfileLocation']>, ParentType, ContextType>;
  lookingFor?: Resolver<Maybe<Array<ResolversTypes['Gender']>>, ParentType, ContextType>;
  mood?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  personality?: Resolver<Maybe<Array<ResolversTypes['PersonalityTrait']>>, ParentType, ContextType>;
  relationshipStatus?: Resolver<Maybe<ResolversTypes['RelationshipStatus']>, ParentType, ContextType>;
  religion?: Resolver<Maybe<ResolversTypes['Religion']>, ParentType, ContextType>;
  sexuality?: Resolver<Maybe<ResolversTypes['Sexuality']>, ParentType, ContextType>;
  smoking?: Resolver<Maybe<ResolversTypes['SmokingHabit']>, ParentType, ContextType>;
  tattoo?: Resolver<Maybe<ResolversTypes['TATTOO']>, ParentType, ContextType>;
  temporaryBirthDate?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  weight?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  work?: Resolver<Maybe<ResolversTypes['ProfileWork']>, ParentType, ContextType>;
  zodiac?: Resolver<Maybe<ResolversTypes['Zodiac']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileLocationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileLocation'] = ResolversParentTypes['ProfileLocation']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  county?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  geo?: Resolver<Maybe<ResolversTypes['Geo']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileTranslationResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileTranslation'] = ResolversParentTypes['ProfileTranslation']> = {
  describeYourself?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ProfileWorkResolvers<ContextType = any, ParentType extends ResolversParentTypes['ProfileWork'] = ResolversParentTypes['ProfileWork']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  company?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  education?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  title?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QueryResolvers<ContextType = any, ParentType extends ResolversParentTypes['Query'] = ResolversParentTypes['Query']> = {
  _?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  aiBotUsers?: Resolver<Array<ResolversTypes['AiBotUser']>, ParentType, ContextType>;
  analytics?: Resolver<Maybe<ResolversTypes['AnalyticsResult']>, ParentType, ContextType>;
  attachmentUploads?: Resolver<Maybe<ResolversTypes['PagedPhotos']>, ParentType, ContextType, RequireFields<QueryAttachmentUploadsArgs, 'paging'>>;
  chat?: Resolver<Maybe<ResolversTypes['Chat']>, ParentType, ContextType, RequireFields<QueryChatArgs, '_id'>>;
  chatBetweenUsers?: Resolver<Maybe<ResolversTypes['Chat']>, ParentType, ContextType, RequireFields<QueryChatBetweenUsersArgs, 'userId1' | 'userId2'>>;
  chats?: Resolver<ResolversTypes['PagedChats'], ParentType, ContextType, RequireFields<QueryChatsArgs, 'paging'>>;
  dashboard?: Resolver<Maybe<ResolversTypes['DashboardData']>, ParentType, ContextType>;
  deletedUsers?: Resolver<Maybe<Array<ResolversTypes['DeletedUser']>>, ParentType, ContextType>;
  getActiveLiveStreams?: Resolver<ResolversTypes['PagedLiveStreams'], ParentType, ContextType, RequireFields<QueryGetActiveLiveStreamsArgs, 'limit'>>;
  getLiveStream?: Resolver<Maybe<ResolversTypes['LiveStream']>, ParentType, ContextType, RequireFields<QueryGetLiveStreamArgs, 'streamId'>>;
  groupPhotos?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  groups?: Resolver<Array<ResolversTypes['Group']>, ParentType, ContextType>;
  hello?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  matchVideosApproval?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
  onboardingHistory?: Resolver<ResolversTypes['OnboardingHistoryData'], ParentType, ContextType, RequireFields<QueryOnboardingHistoryArgs, 'args'>>;
  onboardingStats?: Resolver<ResolversTypes['OnboardingResult'], ParentType, ContextType, RequireFields<QueryOnboardingStatsArgs, 'args'>>;
  paidConversion?: Resolver<ResolversTypes['PaidConversionResult'], ParentType, ContextType, RequireFields<QueryPaidConversionArgs, 'args'>>;
  photoVerifications?: Resolver<Maybe<Array<ResolversTypes['PhotoVerification']>>, ParentType, ContextType>;
  privatePhotos?: Resolver<Maybe<ResolversTypes['PagedPhotos']>, ParentType, ContextType, RequireFields<QueryPrivatePhotosArgs, 'paging'>>;
  privateVideos?: Resolver<Maybe<ResolversTypes['PagedVideos']>, ParentType, ContextType, RequireFields<QueryPrivateVideosArgs, 'paging'>>;
  profilePhotosApproval?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType, RequireFields<QueryProfilePhotosApprovalArgs, 'args'>>;
  publicPostsPendingReview?: Resolver<Maybe<Array<ResolversTypes['Post']>>, ParentType, ContextType>;
  reelComments?: Resolver<ResolversTypes['PagedReelComments'], ParentType, ContextType, RequireFields<QueryReelCommentsArgs, 'paging'>>;
  reelWithComments?: Resolver<ResolversTypes['ReelWithComments'], ParentType, ContextType, RequireFields<QueryReelWithCommentsArgs, 'reelId'>>;
  reelsApproval?: Resolver<ResolversTypes['ReelsApprovalResult'], ParentType, ContextType, RequireFields<QueryReelsApprovalArgs, 'args'>>;
  signupFlow?: Resolver<ResolversTypes['SignupFlowResult'], ParentType, ContextType, RequireFields<QuerySignupFlowArgs, 'args'>>;
  subscriptions?: Resolver<Maybe<ResolversTypes['SubscriptionsResult']>, ParentType, ContextType, RequireFields<QuerySubscriptionsArgs, 'args'>>;
  supportTicket?: Resolver<Maybe<ResolversTypes['SupportTicket']>, ParentType, ContextType, RequireFields<QuerySupportTicketArgs, '_id'>>;
  supportTicketCounts?: Resolver<ResolversTypes['SupportTicketCounts'], ParentType, ContextType>;
  supportTickets?: Resolver<ResolversTypes['PagedSupportTickets'], ParentType, ContextType, RequireFields<QuerySupportTicketsArgs, 'limit'>>;
  survey?: Resolver<ResolversTypes['SurveyData'], ParentType, ContextType, RequireFields<QuerySurveyArgs, '_id'>>;
  surveyAnalytics?: Resolver<ResolversTypes['SurveyAnalytics'], ParentType, ContextType, RequireFields<QuerySurveyAnalyticsArgs, '_id'>>;
  surveyTextAnswers?: Resolver<Array<ResolversTypes['TextAnswer']>, ParentType, ContextType, RequireFields<QuerySurveyTextAnswersArgs, '_id' | 'questionIndex'>>;
  surveys?: Resolver<Array<ResolversTypes['SurveyListData']>, ParentType, ContextType>;
  translateProfile?: Resolver<ResolversTypes['ProfileTranslation'], ParentType, ContextType, RequireFields<QueryTranslateProfileArgs, 'userId'>>;
  translateSupportTicket?: Resolver<ResolversTypes['SupportTicketTranslation'], ParentType, ContextType, RequireFields<QueryTranslateSupportTicketArgs, '_id'>>;
  unverifiedPhotos?: Resolver<Maybe<ResolversTypes['PagedPhotos']>, ParentType, ContextType, RequireFields<QueryUnverifiedPhotosArgs, 'args'>>;
  unverifiedVideos?: Resolver<Maybe<ResolversTypes['PagedVideos']>, ParentType, ContextType, RequireFields<QueryUnverifiedVideosArgs, 'paging'>>;
  user?: Resolver<Maybe<ResolversTypes['User']>, ParentType, ContextType, RequireFields<QueryUserArgs, '_id'>>;
  userActivityMap?: Resolver<ResolversTypes['UserActivityMapResult'], ParentType, ContextType, RequireFields<QueryUserActivityMapArgs, 'args'>>;
  userChats?: Resolver<ResolversTypes['PagedChats'], ParentType, ContextType, RequireFields<QueryUserChatsArgs, 'paging' | 'userId'>>;
  userDiamondStatus?: Resolver<ResolversTypes['UserDiamondStatus'], ParentType, ContextType, RequireFields<QueryUserDiamondStatusArgs, 'userId'>>;
  users?: Resolver<ResolversTypes['PagedUsers'], ParentType, ContextType, RequireFields<QueryUsersArgs, 'paging'>>;
  verifiedPhotos?: Resolver<Maybe<ResolversTypes['PagedPhotos']>, ParentType, ContextType, RequireFields<QueryVerifiedPhotosArgs, 'paging'>>;
  videoChatHistory?: Resolver<ResolversTypes['VideoChatHistory'], ParentType, ContextType, RequireFields<QueryVideoChatHistoryArgs, 'limit' | 'offset'>>;
  videoChatStatus?: Resolver<ResolversTypes['VideoChatStatus'], ParentType, ContextType>;
  voiceRecordings?: Resolver<Maybe<Array<ResolversTypes['User']>>, ParentType, ContextType>;
};

export type QuestionAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionAnalytics'] = ResolversParentTypes['QuestionAnalytics']> = {
  choiceAnalytics?: Resolver<Array<ResolversTypes['ChoiceAnalytics']>, ParentType, ContextType>;
  questionIndex?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAnswers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type QuestionDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['QuestionData'] = ResolversParentTypes['QuestionData']> = {
  choices?: Resolver<Array<Maybe<ResolversTypes['ChoiceData']>>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReelResolvers<ContextType = any, ParentType extends ResolversParentTypes['Reel'] = ResolversParentTypes['Reel']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  byUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  callToAction?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callToActionButtonColor?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  callToActionButtonDelayMs?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  callToActionType?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  description?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  explicit?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  hlsError?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  hlsReady?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  matchVideo?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  premium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  profilePhotoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  tags?: Resolver<Maybe<Array<ResolversTypes['String']>>, ParentType, ContextType>;
  thumbnailBlurhash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  views?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReelCommentResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReelComment'] = ResolversParentTypes['ReelComment']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  byUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  byUserProfilePhotoUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  byUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  reelId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reelThumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReelWithCommentsResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReelWithComments'] = ResolversParentTypes['ReelWithComments']> = {
  comments?: Resolver<Array<ResolversTypes['ReelComment']>, ParentType, ContextType>;
  reel?: Resolver<ResolversTypes['Reel'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReelsApprovalResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['ReelsApprovalResult'] = ResolversParentTypes['ReelsApprovalResult']> = {
  reels?: Resolver<Array<ResolversTypes['Reel']>, ParentType, ContextType>;
  searchedReels?: Resolver<Array<ResolversTypes['Reel']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type ReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['Report'] = ResolversParentTypes['Report']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  byUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  message?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  problem?: Resolver<Maybe<ResolversTypes['ReportProblem']>, ParentType, ContextType>;
  resolved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  resolvedByEmail?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  resolvedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  type?: Resolver<Maybe<ResolversTypes['ReportType']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SignupFlowResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SignupFlowResult'] = ResolversParentTypes['SignupFlowResult']> = {
  premiumPurchased?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepCompleted?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboarding1?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboarding1Active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboarding2?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboarding2Active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboarding3?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboarding3Active?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboardingPaywall?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  stepOnboardingPaywallActive?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalUsers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionCountryDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionCountryData'] = ResolversParentTypes['SubscriptionCountryData']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionData'] = ResolversParentTypes['SubscriptionData']> = {
  active?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  age?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  expireDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  trial?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionSourceDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionSourceData'] = ResolversParentTypes['SubscriptionSourceData']> = {
  count?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionsAnalyticDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionsAnalyticData'] = ResolversParentTypes['SubscriptionsAnalyticData']> = {
  adAttributions?: Resolver<Array<ResolversTypes['AdAttributionData']>, ParentType, ContextType>;
  countries?: Resolver<Array<ResolversTypes['SubscriptionCountryData']>, ParentType, ContextType>;
  sources?: Resolver<Array<ResolversTypes['SubscriptionSourceData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SubscriptionsResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['SubscriptionsResult'] = ResolversParentTypes['SubscriptionsResult']> = {
  analyticData?: Resolver<ResolversTypes['SubscriptionsAnalyticData'], ParentType, ContextType>;
  data?: Resolver<Maybe<Array<ResolversTypes['SubscriptionData']>>, ParentType, ContextType>;
  totalSubscriptions?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalSubscriptionsLast30days?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  totalTrials?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportAttachmentResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportAttachment'] = ResolversParentTypes['SupportAttachment']> = {
  mime?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  name?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  size?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportMessage'] = ResolversParentTypes['SupportMessage']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  attachments?: Resolver<Array<ResolversTypes['SupportAttachment']>, ParentType, ContextType>;
  autoSubmitted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  bounced?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  direction?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  fromName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  fullText?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  historical?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inAppStatus?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  receivedAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  sentBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  via?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportMessageTranslationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportMessageTranslation'] = ResolversParentTypes['SupportMessageTranslation']> = {
  messageId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicket'] = ResolversParentTypes['SupportTicket']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  autoReplyCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  blockedSender?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  category?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  channel?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  displayId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  firstInboundAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  hasAttachments?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  inboundCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  lastInboundAt?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lastOutboundAt?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  messageCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['SupportMessage']>, ParentType, ContextType>;
  needsAdmin?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  notes?: Resolver<Array<ResolversTypes['SupportTicketNote']>, ParentType, ContextType>;
  number?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  preview?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  previewDirection?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  report?: Resolver<Maybe<ResolversTypes['SupportTicketReport']>, ParentType, ContextType>;
  resolution?: Resolver<Maybe<ResolversTypes['SupportTicketResolution']>, ParentType, ContextType>;
  senderEmail?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  senderName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  snoozedUntil?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  source?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  spamReasons?: Resolver<Array<ResolversTypes['String']>, ParentType, ContextType>;
  spamScore?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  subject?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updated?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  user?: Resolver<Maybe<ResolversTypes['SupportTicketUser']>, ParentType, ContextType>;
  userId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketCountsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketCounts'] = ResolversParentTypes['SupportTicketCounts']> = {
  archived?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  needsAdmin?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  open?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  resolved?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  snoozed?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  spam?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  waitingUser?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketNoteResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketNote'] = ResolversParentTypes['SupportTicketNote']> = {
  at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  by?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketReportResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketReport'] = ResolversParentTypes['SupportTicketReport']> = {
  contentId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  problem?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  reportedUserId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  reportedUsername?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketResolutionResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketResolution'] = ResolversParentTypes['SupportTicketResolution']> = {
  at?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  by?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  note?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketTranslationResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketTranslation'] = ResolversParentTypes['SupportTicketTranslation']> = {
  messages?: Resolver<Array<ResolversTypes['SupportMessageTranslation']>, ParentType, ContextType>;
  subject?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SupportTicketUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['SupportTicketUser'] = ResolversParentTypes['SupportTicketUser']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  banned?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  deleted?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  language?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  premium?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurveyAnalyticsResolvers<ContextType = any, ParentType extends ResolversParentTypes['SurveyAnalytics'] = ResolversParentTypes['SurveyAnalytics']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questionAnalytics?: Resolver<Array<ResolversTypes['QuestionAnalytics']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAnswers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurveyDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SurveyData'] = ResolversParentTypes['SurveyData']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  description?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  questions?: Resolver<Array<ResolversTypes['QuestionData']>, ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAnswers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type SurveyListDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['SurveyListData'] = ResolversParentTypes['SurveyListData']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  title?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalAnswers?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TextAnswerResolvers<ContextType = any, ParentType extends ResolversParentTypes['TextAnswer'] = ResolversParentTypes['TextAnswer']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  answer?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalUsersCountryItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalUsersCountryItem'] = ResolversParentTypes['TotalUsersCountryItem']> = {
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  users?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type TotalUsersItemResolvers<ContextType = any, ParentType extends ResolversParentTypes['TotalUsersItem'] = ResolversParentTypes['TotalUsersItem']> = {
  date?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  users?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadFieldResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadField'] = ResolversParentTypes['UploadField']> = {
  key?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  value?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UploadPostInfoResolvers<ContextType = any, ParentType extends ResolversParentTypes['UploadPostInfo'] = ResolversParentTypes['UploadPostInfo']> = {
  fields?: Resolver<Maybe<Array<Maybe<ResolversTypes['UploadField']>>>, ParentType, ContextType>;
  fileName?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  postUrl?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserResolvers<ContextType = any, ParentType extends ResolversParentTypes['User'] = ResolversParentTypes['User']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  admin?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  appVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  banned?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  bannedUntilDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  country?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  created?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  credits?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  deleted?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  describeYourself?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  email?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  firstName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  gender?: Resolver<ResolversTypes['Gender'], ParentType, ContextType>;
  lastActive?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  lastName?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveBan?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  liveStreamingApplication?: Resolver<Maybe<ResolversTypes['LiveStreamingApplication']>, ParentType, ContextType>;
  liveStreamingApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  liveStreamingApprovedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  liveStreamingApprovedDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  loginDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  matchVideo?: Resolver<Maybe<ResolversTypes['Video']>, ParentType, ContextType>;
  matchVideoApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  photos?: Resolver<Maybe<Array<ResolversTypes['Photo']>>, ParentType, ContextType>;
  platform?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  premium?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  profilePhoto?: Resolver<Maybe<ResolversTypes['Photo']>, ParentType, ContextType>;
  profilePhotoApproved?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  profilePhotoAutoApprovedNeedReview?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  pushAvailable?: Resolver<Maybe<ResolversTypes['Boolean']>, ParentType, ContextType>;
  storeFront?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  translationTokens?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  username?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  voicePrompts?: Resolver<Maybe<Array<ResolversTypes['VoicePrompt']>>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserActivityMapDataResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserActivityMapData'] = ResolversParentTypes['UserActivityMapData']> = {
  appPlatform?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  birthDate?: Resolver<Maybe<ResolversTypes['DateTime']>, ParentType, ContextType>;
  city?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  country?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  currentAppVersion?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  lastActive?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  lat?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  lng?: Resolver<ResolversTypes['Float'], ParentType, ContextType>;
  photo?: Resolver<Maybe<ResolversTypes['Photo']>, ParentType, ContextType>;
  premium?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  storeFront?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  userId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  vip?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserActivityMapResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserActivityMapResult'] = ResolversParentTypes['UserActivityMapResult']> = {
  data?: Resolver<Array<ResolversTypes['UserActivityMapData']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type UserDiamondStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['UserDiamondStatus'] = ResolversParentTypes['UserDiamondStatus']> = {
  currentDiamondHistory?: Resolver<Array<ResolversTypes['DiamondHistoryEntry']>, ParentType, ContextType>;
  currentDiamonds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalEarned?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  totalPaid?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoResolvers<ContextType = any, ParentType extends ResolversParentTypes['Video'] = ResolversParentTypes['Video']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  approved?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  isPrivate?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  thumbnailBlurhash?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  thumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadById?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  uploadComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  verified?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoChatConnectionQualityResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChatConnectionQuality'] = ResolversParentTypes['VideoChatConnectionQuality']> = {
  averageLatency?: Resolver<Maybe<ResolversTypes['Float']>, ParentType, ContextType>;
  packetsLost?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  reconnections?: Resolver<Maybe<ResolversTypes['Int']>, ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoChatHistoryResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChatHistory'] = ResolversParentTypes['VideoChatHistory']> = {
  sessions?: Resolver<Array<ResolversTypes['VideoChatHistorySession']>, ParentType, ContextType>;
  totalCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoChatHistorySessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChatHistorySession'] = ResolversParentTypes['VideoChatHistorySession']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  chatId?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  connectionQuality?: Resolver<Maybe<ResolversTypes['VideoChatConnectionQuality']>, ParentType, ContextType>;
  createdAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  durationSeconds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  endReason?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  endedBy?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  messages?: Resolver<Array<ResolversTypes['VideoChatMessage']>, ParentType, ContextType>;
  participant1?: Resolver<ResolversTypes['VideoChatUser'], ParentType, ContextType>;
  participant1JoinedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participant1LeftAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participant2?: Resolver<ResolversTypes['VideoChatUser'], ParentType, ContextType>;
  participant2JoinedAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  participant2LeftAt?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  sessionEndedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  sessionStartedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  status?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  totalMessageCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  type?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  updatedAt?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoChatMessageResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChatMessage'] = ResolversParentTypes['VideoChatMessage']> = {
  fromUserId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  timestamp?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoChatSessionResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChatSession'] = ResolversParentTypes['VideoChatSession']> = {
  sessionDurationSeconds?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  user1?: Resolver<ResolversTypes['VideoChatUser'], ParentType, ContextType>;
  user2?: Resolver<ResolversTypes['VideoChatUser'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoChatStatusResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChatStatus'] = ResolversParentTypes['VideoChatStatus']> = {
  activeSearchersCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  activeSessions?: Resolver<Array<ResolversTypes['VideoChatSession']>, ParentType, ContextType>;
  activeSessionsCount?: Resolver<ResolversTypes['Int'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoChatUserResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoChatUser'] = ResolversParentTypes['VideoChatUser']> = {
  _id?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  photoThumbnailUrl?: Resolver<Maybe<ResolversTypes['String']>, ParentType, ContextType>;
  username?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VideoUploadResultResolvers<ContextType = any, ParentType extends ResolversParentTypes['VideoUploadResult'] = ResolversParentTypes['VideoUploadResult']> = {
  uploadId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadPostInfo?: Resolver<ResolversTypes['UploadPostInfo'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type VoicePromptResolvers<ContextType = any, ParentType extends ResolversParentTypes['VoicePrompt'] = ResolversParentTypes['VoicePrompt']> = {
  created?: Resolver<ResolversTypes['DateTime'], ParentType, ContextType>;
  text?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  uploadComplete?: Resolver<ResolversTypes['Boolean'], ParentType, ContextType>;
  uploadId?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  url?: Resolver<ResolversTypes['String'], ParentType, ContextType>;
  __isTypeOf?: IsTypeOfResolverFn<ParentType, ContextType>;
};

export type Resolvers<ContextType = any> = {
  AdAttributionData?: AdAttributionDataResolvers<ContextType>;
  AiBotUser?: AiBotUserResolvers<ContextType>;
  AnalyticsResult?: AnalyticsResultResolvers<ContextType>;
  AppVersionData?: AppVersionDataResolvers<ContextType>;
  Attachment?: AttachmentResolvers<ContextType>;
  Chat?: ChatResolvers<ContextType>;
  ChoiceAnalytics?: ChoiceAnalyticsResolvers<ContextType>;
  ChoiceData?: ChoiceDataResolvers<ContextType>;
  DashboardData?: DashboardDataResolvers<ContextType>;
  DateTime?: GraphQLScalarType;
  DauItem?: DauItemResolvers<ContextType>;
  DeletedUser?: DeletedUserResolvers<ContextType>;
  DiamondHistoryEntry?: DiamondHistoryEntryResolvers<ContextType>;
  GenderDistribution?: GenderDistributionResolvers<ContextType>;
  Geo?: GeoResolvers<ContextType>;
  GeocodeResult?: GeocodeResultResolvers<ContextType>;
  Group?: GroupResolvers<ContextType>;
  LanguageString?: LanguageStringResolvers<ContextType>;
  LivePagingResult?: LivePagingResultResolvers<ContextType>;
  LiveStream?: LiveStreamResolvers<ContextType>;
  LiveStreamUser?: LiveStreamUserResolvers<ContextType>;
  LiveStreamingApplication?: LiveStreamingApplicationResolvers<ContextType>;
  Location?: LocationResolvers<ContextType>;
  LoginResult?: LoginResultResolvers<ContextType>;
  Message?: MessageResolvers<ContextType>;
  Mutation?: MutationResolvers<ContextType>;
  OnboardingData?: OnboardingDataResolvers<ContextType>;
  OnboardingHistoryData?: OnboardingHistoryDataResolvers<ContextType>;
  OnboardingResult?: OnboardingResultResolvers<ContextType>;
  PagedChats?: PagedChatsResolvers<ContextType>;
  PagedLiveStreams?: PagedLiveStreamsResolvers<ContextType>;
  PagedMessages?: PagedMessagesResolvers<ContextType>;
  PagedPhotos?: PagedPhotosResolvers<ContextType>;
  PagedReelComments?: PagedReelCommentsResolvers<ContextType>;
  PagedSupportTickets?: PagedSupportTicketsResolvers<ContextType>;
  PagedUsers?: PagedUsersResolvers<ContextType>;
  PagedVideos?: PagedVideosResolvers<ContextType>;
  PagingResult?: PagingResultResolvers<ContextType>;
  PaidConversionResult?: PaidConversionResultResolvers<ContextType>;
  PaidConversionSourceData?: PaidConversionSourceDataResolvers<ContextType>;
  Photo?: PhotoResolvers<ContextType>;
  PhotoModeration?: PhotoModerationResolvers<ContextType>;
  PhotoUploadResult?: PhotoUploadResultResolvers<ContextType>;
  PhotoVerification?: PhotoVerificationResolvers<ContextType>;
  PlaceAutocomplete?: PlaceAutocompleteResolvers<ContextType>;
  Post?: PostResolvers<ContextType>;
  Profile?: ProfileResolvers<ContextType>;
  ProfileLocation?: ProfileLocationResolvers<ContextType>;
  ProfileTranslation?: ProfileTranslationResolvers<ContextType>;
  ProfileWork?: ProfileWorkResolvers<ContextType>;
  Query?: QueryResolvers<ContextType>;
  QuestionAnalytics?: QuestionAnalyticsResolvers<ContextType>;
  QuestionData?: QuestionDataResolvers<ContextType>;
  Reel?: ReelResolvers<ContextType>;
  ReelComment?: ReelCommentResolvers<ContextType>;
  ReelWithComments?: ReelWithCommentsResolvers<ContextType>;
  ReelsApprovalResult?: ReelsApprovalResultResolvers<ContextType>;
  Report?: ReportResolvers<ContextType>;
  SignupFlowResult?: SignupFlowResultResolvers<ContextType>;
  SubscriptionCountryData?: SubscriptionCountryDataResolvers<ContextType>;
  SubscriptionData?: SubscriptionDataResolvers<ContextType>;
  SubscriptionSourceData?: SubscriptionSourceDataResolvers<ContextType>;
  SubscriptionsAnalyticData?: SubscriptionsAnalyticDataResolvers<ContextType>;
  SubscriptionsResult?: SubscriptionsResultResolvers<ContextType>;
  SupportAttachment?: SupportAttachmentResolvers<ContextType>;
  SupportMessage?: SupportMessageResolvers<ContextType>;
  SupportMessageTranslation?: SupportMessageTranslationResolvers<ContextType>;
  SupportTicket?: SupportTicketResolvers<ContextType>;
  SupportTicketCounts?: SupportTicketCountsResolvers<ContextType>;
  SupportTicketNote?: SupportTicketNoteResolvers<ContextType>;
  SupportTicketReport?: SupportTicketReportResolvers<ContextType>;
  SupportTicketResolution?: SupportTicketResolutionResolvers<ContextType>;
  SupportTicketTranslation?: SupportTicketTranslationResolvers<ContextType>;
  SupportTicketUser?: SupportTicketUserResolvers<ContextType>;
  SurveyAnalytics?: SurveyAnalyticsResolvers<ContextType>;
  SurveyData?: SurveyDataResolvers<ContextType>;
  SurveyListData?: SurveyListDataResolvers<ContextType>;
  TextAnswer?: TextAnswerResolvers<ContextType>;
  TotalUsersCountryItem?: TotalUsersCountryItemResolvers<ContextType>;
  TotalUsersItem?: TotalUsersItemResolvers<ContextType>;
  UploadField?: UploadFieldResolvers<ContextType>;
  UploadPostInfo?: UploadPostInfoResolvers<ContextType>;
  User?: UserResolvers<ContextType>;
  UserActivityMapData?: UserActivityMapDataResolvers<ContextType>;
  UserActivityMapResult?: UserActivityMapResultResolvers<ContextType>;
  UserDiamondStatus?: UserDiamondStatusResolvers<ContextType>;
  Video?: VideoResolvers<ContextType>;
  VideoChatConnectionQuality?: VideoChatConnectionQualityResolvers<ContextType>;
  VideoChatHistory?: VideoChatHistoryResolvers<ContextType>;
  VideoChatHistorySession?: VideoChatHistorySessionResolvers<ContextType>;
  VideoChatMessage?: VideoChatMessageResolvers<ContextType>;
  VideoChatSession?: VideoChatSessionResolvers<ContextType>;
  VideoChatStatus?: VideoChatStatusResolvers<ContextType>;
  VideoChatUser?: VideoChatUserResolvers<ContextType>;
  VideoUploadResult?: VideoUploadResultResolvers<ContextType>;
  VoicePrompt?: VoicePromptResolvers<ContextType>;
};

